import { decorate, observable, action, computed, toJS } from "mobx";
import moment from 'moment';
import { ColorsSet, colorYellow } from "app/common/utils/StarColorSet";
import ApiClient from "utils/ApiClient";
import { getUniqueId, sleep } from "utils/Utils";
import { getColumnsArray, getColumnDef } from "./helpers/getGridData";
import { cloneDeep, debounce, isEmpty, uniqBy } from "lodash";
import { DIMENSIONS } from "utils/Dimensions";
import { preCalculateActionsColumnWidth } from "./helpers/getActionsColumnWidth";
import AddColumnStore from "app/list/AddColumn/AddColumnStore";
import { NO_BLANKS } from "app/list/filters/Constants";
// console.log(typeof window === 'undefined')
// useStaticRendering(typeof window === 'undefined');
import {
  getFormat,
  formatDate,
  getDateFormat,
} from "../table/helpers/dateFormatter";
import { handleUpdatingData, handleRowDeletion } from "app/websocketManager/eventEmitter";
import { initializeSocket } from "app/websocketManager/socketConnectionManager";
import io from "socket.io-client";

class TableStore {
  cellMetaData = {};
  columns = [];
  data = [];
  allRowsData = [];
  noOfRecordsSelected = 0;
  pendingApiCalls = {};
  listId = 75441650; //TS
  viewId = 645;
  // listId = 73062031;
  // viewId = 4253;
  // formattedData = [];
  columnDefs = [];
  columnsWithAggregation = {};
  currentApiCallsCount = 0;
  isCurrentRowSaving = false;
  pendingActions = [];
  isSubsheet = false;
  parentRow = {};
  isScrollToLastButtonVisible = false;
  newRows = [];
  newColumns = [];
  isFloatingFiltersShown = false;
  addRowsDataLength = 0;
  isLazyLoadEnabled = false;
  isRowAdded = false;
  isPasteSuccess = false;
  pasteColumnTypeId = "";
  userEvents = [];
  loadingColumns = new Set();
  viewColumns = [];
  quickSearchText = "";
  executingEvents = {};
  executingToolbarEvents = {};
  isColumnDeleting = false;
  hiddenColumns = [];
  isTabNameChanging = false;
  isSheetDeleting = false;
  isMailModalVisible = false;
  isReadOnlyCell = false;
  prevClickedCellRowId = "";
  prevClickedCellColumnId = "";
  comments = {};
  rowsWithRestoreIcon = {};
  undoStack = [];
  redoStack = [];
  isCheckBoxGroupDialogOpen = false;
  actionButtons = {
    anchorEl: null,
    currentRowNode: null
  }
  isActionButtonsPopperOpen = false;
  isNewColumnAdded = false;
  errorTooltip = {
    anchorEl: null,
    params: null
  }
  overflowTooltip = {
    anchorEl: null,
    value: null
  }
  loadTypeButtonShown = false;
  previousRowIndexSelected = undefined;
  currentRowIndexSelected = undefined;
  nodesToRefresh = [];
  isExportingLazyLoadData = false;
  isCommentsColumnSaving = false;
  isViewSaving = false;
  isGridCellEditing = false;
  isCommentsColumnPrev = null;
  isSubsheetRecordsDeleted = false;
  currentCommentsElement = null;
  currentCommenteGridCell = null;
  isRowViewEditorOpen = false;
  rowDetailScrollPos = 0;
  constructor(props, containerStore) {
    this.props = props;
    this.gridId = getUniqueId();
    this.isSubsheet = props.isSubsheet || false;
    this.listId = props.listId
    this.containerStore = containerStore;
    this.isAddRowDisabled = props.isAddRowDisabled ?? false;
    this.duplicateColumnsData = {"themeColor" : containerStore?.appStore?.packStore.themeColor || props.themeColor || ''};
    this.duplicateColumnsConfigs = {};
    this.fetchDuplicatesDataForLazyLoad = false;
    this.duplicateRowsThatNeedCountUpdation = {};
    this.hiddenColumnsData = null;
    this.isFilling = false;
    if (this.isSubsheet) {
      this.columns = props.columns
      this.parentColumnId = props.columnId
      this.parentListId = props.parentListId
      this.parentRowId = props.rowId
      this.value = props.value ?? []
      this.dataIncludingSubsheets = props?.dataIncludingSubsheets ?? null;
      this.isEventsColumnHidden = props.isEventsColumnHidden ? true : false
      if (!this.parentRowId) {
        this.parentRow = props.parentRow
      }
      this.addColumnStore = new AddColumnStore(window.appStore, { id: props.listId, name: props.listName }, props.columns, containerStore, true);
      this.addColumnStore.onColumnConfigChange = props.onColumnConfigChange;
      this.addColumnStore.handleColumnDeleteViaSockets = props.handleColumnDeleteViaSockets;
    } else {
      this.viewId = props.viewId
      // this.view = props.view
      this.listConfig = props.listConfig

      this.addColumnStore = new AddColumnStore(window.appStore, props.listConfig.list, props.listConfig.listData, containerStore);
      this.setLazyLoadForView(props.view);

      // let params = new URLSearchParams(window.location?.search);
      // if (params.get("list_id") && params.get("view_id")) {
      // this.listId = params.get("list_id");
      // this.viewId = params.get("view_id");
      // }

      //todo: check if we need to do this in sync;
    }
    // this.fetchData();
    // window.store = this;
  }

  setLazyLoadForView(view) {
    if (view.options?.options?.is_lazy_load) {
      this.isLazyLoadEnabled = true;
      return;
    }

    const viewColumnsLength = view.options?.columns?.length;
    const viewCells = view.total_count * viewColumnsLength;
    const hasJoins = view.options?.joins?.length > 0;
    const maxCells = hasJoins ? 2000 * 20 : 30000 * 10;
    const maxCellsSlowInternet = hasJoins ? 2000 * 20 : 10000 * 10;

    this.isLazyLoadEnabled = viewCells > maxCells || view.size_mb > 30;
    if (this.containerStore.isSlowInternet && !this.isLazyLoadEnabled) {
      this.isLazyLoadEnabled = viewCells > maxCellsSlowInternet || view.size_mb > 10;
    }
  }

  get isTableConfigReadOnly() {
    return this.isSubsheet ? this.props.isTableConfigReadOnly : !this.containerStore.permissions?.canChangeSettings();
  }

  get view() {
    return this.isSubsheet ? undefined : this.containerStore.view;
  }

  setColumns(columns) {
    this.columns = columns;
    this.addColumnStore.setColumns(columns)
  }

  async handleRestore(row_id) {
    try {
      await window.appStore.notificationStore.confirm({
        description: 'This will restore the selected record' + (String(row_id).split(',').length > 1 ? 's' : ''),
      });
      try {
        let resp = await ApiClient.List.restoreLog({
          rowId: row_id,
          listId: this.listId
        })
        if (resp.success) {
          window.appStore.notificationStore.showNotification('Data restored', "success")
          this.refreshData()
        }
      } catch (error) {
        window.appStore.notificationStore.showNotification(error?.response?.message ? error.response.message : "Api Failed", 'error')
      }
    } catch { }
  }

  async fetchUserEvents(isForceFetch = false) {
    if (this.isUserEventsLoaded && !isForceFetch) {
      return;
    }
    try {
      let resp = await ApiClient.List.getUserEvents({
        list_id: this.listId
      });
      this.isUserEventsLoaded = true;
      this.userEvents = resp.data;
    } catch (e) {
      console.log(e);
    }
  }

  setExecutingToolbarEventsStatus(eventId, status) {
    if (status) {
      this.executingToolbarEvents[eventId] = true;
    } else {
      delete this.executingToolbarEvents[eventId];
    }
  }

  getStarColumnHashValue(color) {
    const allColors = {
      ...ColorsSet,
      ...colorYellow,
    };
    return allColors[color] || { color: "#808080", borderColor: "#808080" }; // default to gray if not found
  }
  
  convertIstToCurrentTimeZone(date) {
    const currentOffset = new Date().getTimezoneOffset();
    const offsetDifference = -330;
    const final = currentOffset - offsetDifference
    date.setMinutes(date.getMinutes() - final);
    return date;
  }

  resetSelectedRecordsCount() {
    this.noOfRecordsSelected = 0;
  }

  addSelectedRecordsCount(count) {
    this.noOfRecordsSelected = this.noOfRecordsSelected + count;
  }

  get activeToolbarActionButtons() {
    const currentEventIds = new Set();
    const currentEvents = [];
    this.gridApi.getSelectedRows().map((node) => {
      this.userEvents.map((event) => {
        if (!node.hasOwnProperty("is_event_" + event.id + "_disabled") || node?.["is_event_" + event.id + "_disabled"] == "0") {
          if (!currentEventIds.has(event.id)) {
            currentEventIds.add(event.id);
            currentEvents.push({
              id: event.id,
              name: event.label,
              position:event.position
            });
          }
        }
      });
    });
    return currentEvents;
  }

  getActiveRowActionButtons(node) {
    const currentEventIds = new Set();
    const currentEvents = [];
    this.userEvents.map((event) => {
      if (node?.["is_event_" + event.id + "_disabled"] == "0" || (node?.["is_event_" + event.id + "_disabled"] != "0" && event.criteria_action == "disable" ) ) {
        if (!currentEventIds.has(event.id)) {
          currentEventIds.add(event.id);
          currentEvents.push({
            id: event.id,
            name: event.name,
          });
        }
      }
    });
    return currentEvents;
  }

  async executeBulkActions(props, event) {
    try {
      let selectedNodes = props.gridApi.getSelectedNodes();
      let idsList = { rowIdsList: [], uniqueIdsList: [] };
      selectedNodes.map((node) => {
        idsList.rowIdsList.push(node.data.row_id);
        idsList.uniqueIdsList.push(node.id);
      });
      const resp = await ApiClient.List.executeAction({
        list_id: this.listId,
        row_ids: idsList.rowIdsList.join(),
        event_id: event.id,
        client_id: window.appStore.clientId ?? ''
      });
      if (!resp.success) {
        return;
      }
      for (let i = 0; i < idsList.uniqueIdsList.length; i++) {
        let node = props.gridApi.getRowNode(idsList.uniqueIdsList[i]);
        for (let j = 0; j < resp.data.rows_modified.length; j++) {
          if (node.data.row_id == resp.data.rows_modified[j].row_id) {
            Object.keys(resp.data.rows_modified[j]).forEach((columnId) => {
              try {
                if (!window.appStore.socket.connected && (this.duplicateColumnsData[columnId] || (this.isSubsheet && this.duplicateColumnsData[columnId + '_' + this.parentRowId]))) { //Subsheet validation will be helpful when in future executeBulkAction is enabled for subsheet also.
                  const oldValue = node.data[columnId];
                  const newValue = resp.data.rows_modified[j][columnId];
                  if (oldValue != newValue) {
                    this.updateCountAfterExecutingActions(columnId, newValue, oldValue, node.data?.row_id);
                  }
                }
                node.data[columnId] = resp.data.rows_modified[j][columnId];
              } catch (e) {
                console.log('Error', e);
              }
            });
            node.setData(node.data);
            break;
          }
        }
      }
      
      this.executeClientEventHandlers(idsList.rowIdsList, resp.data);
    } catch (e) {
      Ext.Msg.alert("Error", e.message);
    }
  }

  showMailModal(){
    this.isMailModalVisible = true;
  }

  closeMailModal(){
    this.isMailModalVisible = false;
  }

  unselectSelectedRowsInGrid = () => {
    this.resetSelectedRecordsCount();
    this.gridApi?.deselectAll();
    let parentDOM = document.getElementById(this.gridId);
    let array = Array.from(
      parentDOM.getElementsByClassName("rowIdSelection")
    );
    parentDOM.querySelectorAll(
      "input[id='defaultChecked']"
    )[0].checked = false;
    array.map((row) => {
      if (row.checked) {
        row.checked = false;
      }
    });
  }

  updateGridDataAfterDelete(rowIdsList = []) {
    let selectedNodes = this.gridApi.getSelectedNodes();
    if (!selectedNodes || selectedNodes.length === 0) {
      for (let i = 0; i < rowIdsList.length; i++) {
        var selectedNode = this.getRowNodeById(rowIdsList[i])?.node;
        this.updateDuplicatesCountAfterCellDeletion(selectedNode?.data, !this.isLazyLoadEnabled);
      }
    }
    if (!this.isLazyLoadEnabled) {
      let selectedData = this.gridApi.getSelectedRows();
      this.gridApi.applyTransaction({ remove: selectedData });
      selectedNodes.map((node) => {
        let newRowIndex = this.newRows.findIndex(row => row.uniqueId === node.id);
        if (newRowIndex >= 0 && node.data?.row_id) {
          this.updateDuplicatesCountAfterCellDeletion(node.data);
          this.newRows.splice(newRowIndex, 1);
        }
        let savedRowIndex = this.allRowsData.findIndex(row => row.uniqueId === node.id);
        if (savedRowIndex >= 0 && node.data?.row_id) {
          this.updateDuplicatesCountAfterCellDeletion(node.data);
          this.allRowsData.splice(savedRowIndex, 1);
        }
        this.refreshGroupedColHeaderWhileUpdation(node);
      });
    } else {
      selectedNodes.map((node) => {
        this.updateDuplicatesCountAfterCellDeletion(node.data, false);
      });
      this.gridApi.refreshInfiniteCache();
      this.newRows.splice(0, this.newRows.length);
    }
    this.resetSavedRowsCount = !this.resetSavedRowsCount;
  }
  async bulkDeleteAction(rowId) {
    let rowIdsList = [];
    if (rowId) {
      rowIdsList.push(rowId);
    } else {
      let selectedNodes = this.gridApi.getSelectedNodes();
      selectedNodes.map((node) => {
        if (node?.data?.row_id) {
          rowIdsList.push(node.data.row_id);
        }
      });
    }
    let rowIds = rowIdsList.join();
    if (rowIds.length > 0) {
      try {
        const resp = await ApiClient.List.deleteAction({
          list_id: this.listId,
          delete_row_id: rowIds,
          parent_column_id : this.isSubsheet ? this.parentColumnId : "",
          parent_row_id : this.isSubsheet ? this.parentRowId : "" ,
          parent_list_id : this.isSubsheet ? this.parentListId : "",
        });
        if (resp.success) {
          this.updateGridDataAfterDelete(rowIdsList);
          handleRowDeletion(JSON.stringify(rowIdsList), this.listId, this.isSubsheet);
        }
      } catch (e) {
        Ext.Msg.alert("Error", e.message ?? "Something went wrong");
      }
    } else {
      this.updateGridDataAfterDelete(rowIdsList);
    }
  }

  updateDuplicatesCountAfterCellDeletion (rowData, shouldRefresh = true) {
    try {
      const highlightedColumnIds = Object.keys(this.duplicateColumnsData);
      const isSubsheet = this.isSubsheet;

      highlightedColumnIds.forEach(columnId => {
        if (columnId !== "themeColor" && !isSubsheet) {
          this.modifyDuplicatesDataCount(columnId, rowData[columnId], false, rowData?.row_id, '', shouldRefresh);
        } else if(columnId !== "themeColor" && isSubsheet) {
            var subsheetColumnId = columnId.slice(0, columnId.lastIndexOf('_'));
            this.modifyDuplicatesDataCount(columnId, rowData[subsheetColumnId], false, rowData?.row_id, subsheetColumnId, shouldRefresh);
        }
      });
    } catch (e) {
      console.log('Error', e);
    }
  }

  updateSubsheetGridDataAfterDelete(props) {
    if (!props.store.isLazyLoadEnabled) {
      const deletingNode = this.gridApi.getRowNode(props.data.uniqueId);
      props.api.applyTransaction({ remove: [props.data] });
      this.refreshGroupedColHeaderWhileUpdation(deletingNode);
      let newRowIndex = this.newRows
        .map((obj) => {
          return obj.uniqueId;
        })
        .indexOf(props.data.uniqueId);
      if (newRowIndex >= 0 && this.newRows[newRowIndex]?.row_id) {
        this.updateDuplicatesCountAfterCellDeletion(this.newRows[newRowIndex]);
        this.newRows.splice(newRowIndex, 1);
      }
      let savedRowIndex = this.allRowsData.findIndex(row => row.uniqueId === props.data.uniqueId);
      if (savedRowIndex >= 0 && this.allRowsData[savedRowIndex]?.row_id) {
        this.updateDuplicatesCountAfterCellDeletion(this.allRowsData[savedRowIndex]);
        this.allRowsData.splice(savedRowIndex, 1);
      }
    } else {
      props.api.refreshInfiniteCache();
      this.newRows.splice(0, this.newRows.length);
    }
    this.resetSavedRowsCount = !this.resetSavedRowsCount;
  }
  async deleteAction(props) {
    if (props.data.row_id) {
      try {
        const resp = await ApiClient.List.deleteAction({
          list_id: this.listId,
          delete_row_id: props.data.row_id,
          parent_column_id : this.isSubsheet ? this.parentColumnId : "",
          parent_row_id : this.isSubsheet ? this.parentRowId : "" ,
          parent_list_id : this.isSubsheet ? this.parentListId : "",
        });
        if (resp.success) {
          this.updateSubsheetGridDataAfterDelete(props);
          handleRowDeletion(JSON.stringify([props.data.row_id]), this.listId, this.isSubsheet);
        }
      } catch (e) {
        Ext.Msg.alert("Error", e.message ?? "Something went wrong");
      }
    } else {
      this.updateSubsheetGridDataAfterDelete(props);
    }
  }

  updateCountAfterExecutingActions(columnId, newValue, oldValue, rowId) {
    const columnTypeId = this.duplicateColumnsConfigs[columnId]?.column_type_id ?? '';
    if(columnTypeId && this.isValidCellValue(columnTypeId, newValue)){
      if (!this.isSubsheet) {
        this.modifyDuplicatesDataCount(columnId, newValue, true, rowId);
      } else {
          this.modifyDuplicatesDataCount(columnId + '_' + this.parentRowId, newValue, true, rowId, columnId);
      }
    }
    if(columnTypeId && this.isValidCellValue(columnTypeId, oldValue)){
      if (!this.isSubsheet) {
        this.modifyDuplicatesDataCount(columnId, oldValue, false, rowId);
      } else {
          this.modifyDuplicatesDataCount(columnId + '_' + this.parentRowId, oldValue, false, rowId, columnId);
      }
    }
  }

  async executeAction(rowIds, uniqueId, eventId) {
    try {
      let resp = await ApiClient.List.executeAction({
        list_id: this.listId,
        row_ids: rowIds,
        event_id: eventId,
        client_id: window.appStore.clientId ?? ''
      });
      let idsOfRowsModified = [];
      resp.data.rows_modified.map((row) => {
        idsOfRowsModified.push(row.row_id);
      });
      if (resp.success) {
        let node = this.gridApi.getRowNode(uniqueId);
        if( resp.data.rows_modified && typeof(resp.data.rows_modified) == "object" && resp.data.rows_modified.length > 0 ) {
          Object.keys(resp.data.rows_modified[0]).forEach((columnId) => {
            try {
              if (!window.appStore.socket.connected && (this.duplicateColumnsData[columnId] || (this.isSubsheet && this.duplicateColumnsData[columnId + '_' + this.parentRowId]))) {
                const newValue = resp.data.rows_modified[0][columnId];
                const oldValue = node.data[columnId];
                if (newValue != oldValue) {
                  this.updateCountAfterExecutingActions(columnId, newValue, oldValue, node.data?.row_id);
                }
              }
              node.data[columnId] = resp.data.rows_modified[0][columnId];
            } catch (e) {
              console.log('Error', e);
            }
          });
        }
        node.setData(node.data);
        this.executeClientEventHandlers([rowIds], resp.data);
      }
    } catch (e) {
      console.log(e);
    }
  }

  async executeClientEventHandlers(rowIdsList, respData) {
    if (respData.client_handlers && respData.client_handlers.length > 0) {
      let actionButtonConfig = {
        color_codes: this.containerStore?.listConfig?.colorCodes,
        custom_events: this.userEvents,
        list: this.containerStore?.listConfig?.list,
        list_columns: this.containerStore?.listConfig?.listData,
        list_permissions: this.containerStore?.listConfig?.listPermissions,
      };
      const actionButtonPermissions = Ext.create(
        "TL.list.permissions.Permissions",
        {
          permissions: this.containerStore?.listConfig?.listPermissions,
        }
      );
      TL.list.events.EventManager.executeHandlers(
        rowIdsList,
        respData.client_handlers,
        {
          config: actionButtonConfig,
          permissions: actionButtonPermissions,
          listData: actionButtonConfig.list,
          listeners: {
            "reload-grid": async function (listId, rows) {
              if (!window.appStore.socket.connected) {
                let isTargetSheetSame = false;
                for(let i = 0; i < respData.client_handlers.length; i++){
                  isTargetSheetSame = isTargetSheetSame || (respData.client_handlers[i]?.list_id == actionButtonConfig.list?.id);
                }
                if ((listId === actionButtonConfig.list?.id || !listId) && isTargetSheetSame) {
                  let alloldRowNodes = [];
                  let isOtherHandler = false;
                  if (Object.keys(this.duplicateColumnsData).length > 1 && !this.isLazyLoadEnabled) {
                    for(let i = 0; i < respData.client_handlers.length; i++){
                      let rowNodes = [];
                      if((respData.client_handlers[i]['type'] == 'update-row-client' || respData.client_handlers[i]['type'] == 'set-column-client' || respData.client_handlers[i]['type'] == 'generate-barcode-client') && respData.client_handlers[i]?.list_id == actionButtonConfig.list?.id){
                        for(let j = 0; j < respData.client_handlers[i]['row_ids'].length; j++){
                          var rowNode = {...this.gridApi.getRowNode(respData.client_handlers[i]['row_ids'][j])};
                          rowNodes.push(rowNode);
                        }
                      } else {
                        isOtherHandler = true;
                        break;
                      }
                      alloldRowNodes.push(rowNodes);
                    }
                  }
                  if (isTargetSheetSame) {
                    await this.refreshData(isOtherHandler || this.isLazyLoadEnabled);
                  }
                  let nodes = [];
                  for(let i = 0; i < respData.client_handlers.length; i++){
                    if((respData.client_handlers[i]['type'] == 'update-row-client' || respData.client_handlers[i]['type'] == 'set-column-client' || respData.client_handlers[i]['type'] == 'generate-barcode-client') && respData.client_handlers[i]?.list_id == actionButtonConfig.list?.id){
                      for(let j = 0; j < respData.client_handlers[i]['row_ids'].length; j++){
                        const node = this.gridApi.getRowNode(respData.client_handlers[i]['row_ids'][j]);
                        if (Object.keys(this.duplicateColumnsData).length > 1 && !this.isLazyLoadEnabled && !isOtherHandler) {
                          const highlightedColumnIds = Object.keys(this.duplicateColumnsData);
                          highlightedColumnIds.forEach(columnId => {
                              if (columnId !== "themeColor") {
                                  const newValue = node?.data[columnId] ?? '';
                                  const oldValue = alloldRowNodes[i][j]?.data[columnId] ?? '';
                                  if (newValue != oldValue) {
                                    this.updateCountAfterExecutingActions(columnId, newValue, oldValue, node?.data?.row_id);
                                  }
                              }
                          });
                        }
                        // nodes.push(node);
                      }
                    }
                  }
                  if(nodes.length > 0){
                    this.gridApi.redrawRows({ rowNodes: nodes });
                  }
                }
              }
              if (window.appStore?.configStore?.config?.site?.server_url === "https://genesisfoundation.tigersheet.com") {
                await this.refreshData();
                let clientNodesToBeRefreshed = [];
                try {
                  for(let i = 0; i < rowIdsList.length; i++){
                    let node = this.gridApi.getRowNode(rowIdsList[i]);
                    if(node) {
                      clientNodesToBeRefreshed.push(node);
                    }
                  }
                } catch (error) {
                  console.log('error while fetching node');
                }
                this.gridApi.redrawRows({rowNodes: clientNodesToBeRefreshed});
              }
            },
            scope: this,
          },
        }
      );
    }
    if (respData.warnings && respData.warnings.length > 0) {
      window.appStore.notificationStore.showNotification(
        respData.warnings ? respData.warnings : respData.msg,
        "caution"
      );
    } else if (!respData.client_handlers || ( typeof(respData.client_handlers) == "object" &&  respData.client_handlers.length == 0 )) {
      window.appStore.notificationStore.showNotification(
        "Action has been executed successfully. The number of Rows affected: " +
          respData.rows_modified.length,
        "success"
      );
    }
  }

  async fetchData(options = {}, fetchDuplicatesData = false) {
    this.isLoading = true;
    const isSubsheetView = this.view?.type == "table" &&
      this.view?.list_id &&
      this.view?.options?.main_list_id &&
      this.view?.list_id != this.view?.options?.main_list_id;

    if (this.isSubsheet) {
      await this.fetchDataForSubsheet();
      if (fetchDuplicatesData) {
        await this.getDuplicateColumnsData({});
      }
      this.isLoading = false;
      return;
    }

    try {
      const listId = this.listId;
      let resp;

      if (
        this.view?.type == "table" &&
        this.view?.list_id &&
        this.view?.options?.main_list_id &&
        this.view?.list_id != this.view?.options?.main_list_id &&
        this.isLazyLoadEnabled
      ) {
        if (options.sort?.length >= 1) {
          options.sort.map((option) => {
            if (
              option.hasOwnProperty("property") &&
              option.property == "parent_row_id"
            ) {
              option.property = "row_id";
            }
          });
        }
      }

      if (this.isCriteriaModified || this.isNewColumnAdded || this.containerStore.unSavedViewOfEditReport) {
        const view = cloneDeep(this.view);
        view.id = -1;
        view.criteria = this.modifiedCriteria ?? this.view.criteria; 
        const newColumns = [ ...view.options.columns, ...this.newColumns ].filter(col => col.alias_path !== "commentsId");
        view.options.columns = newColumns;
        resp = await ApiClient.Views.runView({
          list_id: listId,
          view,
          limit: this.shouldLoadAllRows ? 100000 : 1,
          ...options,
        });
        if (!this.isNewColumnAdded) {
          if (!this.resetCriteriaIfSame(resp.data.view.criteria)) {
            this.modifiedCriteria = resp.data.view.criteria;
          }
        }
      } else {
        resp = await ApiClient.Views.getViewData({
          list_id: listId,
          view_id: this.viewId,
          limit: this.shouldLoadAllRows ? 100000 : 1,
          ...options,
        });
      }

      if (
        this.view?.type == "table" &&
        this.view?.list_id &&
        this.view?.options?.main_list_id &&
        this.view?.list_id != this.view?.options?.main_list_id
      ) {
        resp.data?.data?.map((row) => {
          row["parent_row_id"] = row.row_id;
          row.row_id = row.subsheet_row_id;
          row.uniqueId = row.subsheet_row_id;
          delete row["subsheet_row_id"];
        });
      }

      let operation = []
      if(this.listConfig?.list?.is_log_sheet == 1){
         operation = resp.data?.columns?.filter(el => el.name == "Operation")
      }

      this.rowsWithRestoreIcon = {};
      resp.data.data.map(row => {
        this.comments[row.row_id] = row.comments_count;
        if (this.listConfig?.list?.is_log_sheet == 1 && operation && operation.length > 0 && (
          ['delete-row', 'delete-handler', 'delete-event'].includes(row["column_" + operation[0].id])
        )) {
          this.rowsWithRestoreIcon[row.row_id] = true
        }
      })

      if (isEmpty(this.columnDefs)) {
        this.formatColumns(resp.data.columns);
      }

      if (this.shouldLoadAllRows) {
        this.allRowsData = resp.data.data;
      }
      if (fetchDuplicatesData && !isSubsheetView) {
        await this.getDuplicateColumnsData();
      }
      if (process.env.REACT_APP_IS_WEB_SOCKET_ENABLED && window.appStore.is_websocket_enabled && this.view?.type == "table" && (!window.appStore.socket || !window.appStore.socket.connected)) {
        initializeSocket();
      }

      if (resp && resp.data && resp.data.columns) {
        this.fetchAndStoreHiddenColumnsData(resp.data.columns, listId, options);
      }

      this.isLoading = false;
      return resp;
    } catch (e) {
      if (e.response?.message === "Memory Exhausted" && !this.isLazyLoadEnabled) {
        this.isLazyLoadEnabled = true;
        this.updateViewAsLazyLoad();
        this.addGrid();
        return;
      }
      Ext.Msg.alert("Error", e.response?.message ?? "Something went wrong");
      console.error(e);
      // if (e.message === "Session expired. Please login again!") {
      // let resp = await ApiClient.Views.login({
      //   email: "vinod.sai@riktamtech.com",
      //   password: "2342423",
      // });
      // this.fetchData(options);
      // }
    }
    if (process.env.REACT_APP_IS_WEB_SOCKET_ENABLED && window.appStore.is_websocket_enabled && !window.appStore.socket.connected && this.view?.type == "table") {
      initializeSocket();
    }
    this.isLoading = false;
  }

  checkIfHiddenFieldsExists (columns = []) {
    const cols = columns.length == 0 ? this.columns : columns;
    const visibleColumns = cols.filter((col) => col.column_type_id != '6');
    const allColumns = this.listConfig.listData.filter((col) => col.column_type_id != '6');
    return allColumns.length - visibleColumns.length;
  }

  async fetchAndStoreHiddenColumnsData(columns, listId, options) {
    try {
      const hiddenFieldsCount = this.checkIfHiddenFieldsExists(columns);
      if (columns && hiddenFieldsCount > 0) {
        const visibleColumns = columns.map(col => col.id);
        const hiddenData = await ApiClient.List.getHiddenColumnsData({
          list_id: listId,
          view_id: this.viewId,
          user_id: window.LOGGED_IN_USER.user_id ?? '',
          visible_columns: JSON.stringify(visibleColumns),
          limit: this.shouldLoadAllRows ? 100000 : 1,
          ...options,
        });
        if (hiddenData && hiddenData.success && hiddenData.data) {
          this.hiddenColumnsData = hiddenData.data;
        } else if (hiddenData?.msg) {
          console.log(hiddenData.msg);
        }
      }
    } catch (error) {
      console.log('Fetching hidden fields error');
    }
  }

  getDuplicateColumnsData = async (duplicateColumnIds = {}, subsheetId = "") => {
    let duplicateData;
    if(Object.keys(duplicateColumnIds).length == 0) {
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i]?.options?.is_highlighted){
          duplicateColumnIds["column_" + this.columns[i]['id']] = this.columns[i]['column_type_id'];
        }
      }
    }
    try {
      if (Object.keys(duplicateColumnIds).length > 0) {
        let duplicateData = null;
        if (this.isSubsheet && this.parentListId && this.parentRowId) {
          duplicateData = await ApiClient.List.getDuplicateColumnsData({
            list_id: subsheetId ? subsheetId : this.listId,
            duplicate_column_ids: duplicateColumnIds,
            is_Subsheet: this.isSubsheet,
            parent_list_id: this.parentListId,
            parent_row_id: this.parentRowId
          });
        } else if (!this.isSubsheet) {
          duplicateData = await ApiClient.List.getDuplicateColumnsData({
            list_id: subsheetId ? subsheetId : this.listId,
            duplicate_column_ids: duplicateColumnIds,
            is_Subsheet: this.isSubsheet,
            parent_list_id: '',
            parent_row_id: ''
          });
        }
        if (duplicateData && duplicateData['success'] && duplicateData['data']) {
          const duplicateValues = duplicateData['data']
          this.duplicateColumnsData = {...this.duplicateColumnsData, ...duplicateValues};
          for (let i=0; i < this.columns.length; i++) {
            if (Object.keys(duplicateColumnIds).includes(this.columns[i]?.dataIndex)) {
              this.duplicateColumnsConfigs[this.columns[i]?.dataIndex] = this.columns[i];
            }
          }
        }
      }
    } catch (e) {
      Ext.Msg.alert("Error", e.response?.message ?? "Something went wrong");
      console.error(e);
    }
  }

  updateViewAsLazyLoad = async () => {
    this.view.options.options = this.view.options.options || {};
    this.view.options.options.is_lazy_load = true;
    await this.saveView();
  }

  refreshData = async (fetchDuplicatesData = false) => {
    this.cellMetaData = {};
    const newRowsAfterRefresh = [];
    this.newRows.map((row, index) => {
      if (row.row_id == "") {
        newRowsAfterRefresh.push(row);
      }
    });
    this.newRows = newRowsAfterRefresh;
    if (!this.isLazyLoadEnabled) {
      await this.refreshCustomModel(fetchDuplicatesData);
      return;
    }
    this.gridApi.showLoadingOverlay();
    console.log('In refreshData before executing addDataSource..., fetchDuplicatesData: ', fetchDuplicatesData);
    this.fetchDuplicatesDataForLazyLoad = fetchDuplicatesData;
    this.addDataSource(this.params);
  }

  setAgGridColumnDefs(){
    this.gridApi.setColumnDefs(this.columnDefs);
  }

  showLoadingOverlay() {
    this.gridApi?.showLoadingOverlay();
  }

  async refreshCustomModel(fetchDuplicatesData = false) {
    this.showLoadingOverlay();

    await this.fetchData({}, fetchDuplicatesData);
    await this.fetchUserEvents(true);
    this.allSavedRowsCount = this.allRowsData.length;
    this.setAllRowsData(this.params);
    this.resetSavedRowsCount = !this.resetSavedRowsCount;
    if (!this.isLazyLoadEnabled && Object.keys(this.duplicateColumnsData).length > 1 && fetchDuplicatesData) {
      this.redrawRefreshedRows();
    }
  }

  redrawRefreshedRows(columnId = '', value = '', currentRowId = '', singleRecordRefresh = false) {
    try {
      const firstVisibleRowIndex = this.gridApi?.getFirstDisplayedRow();
      const lastVisibleRowIndex = this.gridApi?.getLastDisplayedRow();
      let nodesToBeRefreshed = [];
      for (let i = firstVisibleRowIndex; i <= lastVisibleRowIndex; i++) {
        var node = this.gridApi.getDisplayedRowAtIndex(i);
        let nodeData = node.data;
        if (singleRecordRefresh) {
          if (node && nodeData && nodeData?.row_id !== "+") {
            const nodeValue = node?.data ? node?.data[columnId] : '';
            const isValueEqual = node?.data && ["5", "17", "22"].includes(this.duplicateColumnsConfigs[columnId]?.column_type_id) ? Number(nodeValue) == Number(value) : nodeValue == value;
            if (columnId && node?.data && isValueEqual && node?.data?.row_id !== currentRowId) {
              nodesToBeRefreshed.push(node);
              if (!this.isFilling) {
                break;
              }
            }
          }
        } else {
          nodesToBeRefreshed.push(node);
        }
      }
      if (nodesToBeRefreshed.length > 0) {
        this.gridApi.redrawRows({rowNodes: nodesToBeRefreshed});
      }
    } catch (e) {
      console.log('Error', e);
    }
  }

  addDataSource(params = this.params) {
    var dataSource = {
      rowCount: null,
      getRows: async ({ request, successCallback, ...params }) => {
        // const params = request;
        // console.log(params, otherParams)
        const criteria = this.getCriteriaStringFromFilterModel(params.filterModel);
        const limit = params.endRow - params.startRow
        const options = {
          page: 1 + params.startRow / limit,
          start: params.startRow,
          limit: limit,
          criteria: criteria,
        };
        let data, rowsData;

        if (params.sortModel) {
          options.sort = this.getSortStringFromModel(params.sortModel);
        }
        this.currentFilterModel = params.filterModel;
        if (this.isSubsheet) {
          data = { totalCount: this.data.length }
          rowsData = this.data;
        } else {
          console.log('Call to dataSource.getRows before fetchData, fetchDuplicatesDataForLazyLoad: ', this.fetchDuplicatesDataForLazyLoad);
          data = await this.fetchData(options, this.fetchDuplicatesDataForLazyLoad);
          rowsData = data.data.data;
          this.newRows = this.newRows.filter(newRow => newRow.row_id === "");
        }
        this.fetchDuplicatesDataForLazyLoad = false;
        if (window.LOGGED_IN_USER.domain == "aryamotors") {
          if (this.newRows.length < 100) {
            for (let i = this.newRows.length; i < 100; i++) {
              this.getNewRow({});
            }
          }
        } else if (this.newRows.length < 10) {
          for (let i = this.newRows.length; i < 10; i++) {
            this.getNewRow({});
          }
        }
        if (params.endRow >= data.totalCount) {
          rowsData = [...rowsData, ...this.newRows, this.getAddRowData()]
        }
        this.allSavedRowsCount = parseInt(data.totalCount);
        successCallback(this.formatDataForGrid(rowsData), this.allVisibleGridRowsCount);
        let focusedCell = this.gridApi.getFocusedCell();
        if (focusedCell) {
          this.gridApi.setFocusedCell(
            focusedCell.rowIndex,
            focusedCell.column?.colId
          );
        }
      },
    };
    params.api.setColumnDefs(this.columnDefs);
    if (this.shouldLoadAllRows) {
      this.setAllRowsData(params);
      this.onAgGridFilterChanged();
      return;
    }
    params.api.setDatasource(dataSource);
  }

  getColumnValue = (column, value) => {
    let columnTypeId = parseInt(column.cellRendererParams.columnTypeId);

    if (columnTypeId == 4 || columnTypeId == 16) {
      if (value === "0000-00-00" || value === "0000-00-00 00:00:00" || !value)
        return ""; //params.value;
      let dateformatToUpdate = getDateFormat(column.rowGroupOption);
      let columnFormat = column.cellRendererParams.columnOptions.format;
      let v1 = moment(value, "YYYY-MM-DD HH:mm:ss").format(dateformatToUpdate);

      let outputValue = moment(
            value,
            "YYYY-MM-DD"
          ).format(dateformatToUpdate);

      return outputValue;
    }
    else if(columnTypeId == 9 && value && value !== "+r0w"){
      if(value == "[]") {
        return "";
      }
      try {
        const fileData = JSON.parse(value);
        let formattedValue = "";
        fileData.forEach((file) => {
            formattedValue = formattedValue ? formattedValue + ", " + file['name'] : file["name"];
        });
        return formattedValue;
      } catch (error) {
      }
    }

    return value ? value : "";
  };

  setAllRowsData = (params) => {
    const groupingColumns = this.columnDefs.filter((colDef) => colDef.rowGroup);

    if (!groupingColumns) {
      return;
    }

    const groupedData = {};
    const groupedColIds = {};
    this.allRowsData.forEach((row) => {
      let currentLevel;
      let currentLevelColIds;

      if (!row.uniqueId) {
        row.uniqueId = row.row_id;
      }
      groupingColumns.forEach((col) => {
        let value = this.getColumnValue(col, row[col.field]);
        if (!currentLevel) {
          groupedData[value] = groupedData[value] ?? {};
          let colId = groupedColIds[value]
            ? groupedColIds[value]["colId"]
              ? groupedColIds[value]["colId"]
              : []
            : [];
          groupedColIds[value] = groupedColIds[value] ?? {};
          groupedColIds[value]["colId"] = [...colId, row[col.field]];
          currentLevel = groupedData[value];
          currentLevelColIds = groupedColIds[value];
          return;
        }
        currentLevel[value] = currentLevel[value] ?? {};
        currentLevel = currentLevel[value];

        currentLevelColIds[value] = currentLevelColIds[value] ?? {};
        let colId = currentLevelColIds[value]
          ? currentLevelColIds[value]["colId"]
            ? currentLevelColIds[value]["colId"]
            : []
          : [];
        currentLevelColIds[value]["colId"] = [...colId, row[col.field]];
        currentLevelColIds = currentLevelColIds[value];
      });
    });

    const addRowsData = [];
    this.getAddRowsDataFromGroupedData(
      groupingColumns,
      groupedData,
      addRowsData,
      {},
      0,
      groupedColIds
    );

    this.addRowsDataLength = addRowsData.length;

    if (addRowsData.length === 0) {
      addRowsData.push(this.getAddRowData());
    }
    const emptyRows = [];
    this.newRows.map((row, index) => {
      if (row.row_id == "") {
        emptyRows.push(row);
      }
    });
    this.newRows = emptyRows;
    params.api.setRowData([
      ...this.allRowsData,
      ...this.newRows,
      ...addRowsData,
    ]);
    if (this.isGridGrouped) {
      params.api.expandAll();
    }
  };

  resetCount = () => {
    this.addRowsDataLength = 0;
  }

  getRowsDataCount = () => {
    if (this.isLazyLoadEnabled) {
      return this.gridApi.getInfiniteRowCount() - 1;
    }
    return (
      this.allRowsData.length + this.addRowsDataLength + this.newRows.length
    );
  };

  getNextRowNode = (currentNodeId) => {
    let loadAllRowsData = [];
    let nextRowIndex;
    this.gridApi.forEachNode(function (node, nodeIndex) {
      if (node.data && node.data.uniqueId === currentNodeId) {
        nextRowIndex = nodeIndex + 1;
      }
      loadAllRowsData.push(node.data);
    });
    return loadAllRowsData[nextRowIndex];
  };

  addRowOnGrid = (rowIndex, nodeId, context, columnId) => {
    if (this.isGridGrouped) {
      let nextRowNode = this.getNextRowNode(nodeId);
      if (nextRowNode && nextRowNode.row_id === "+") {
        context.addRow(nextRowNode);
      }
    } else {
      let rowsCount = this.getRowsDataCount();
      if (rowIndex >= rowsCount) {
        if (this.isLazyLoadEnabled) {
          this.isRowAdded = true;
          if(this.isCurrentRowSaving){
            const action = {
              action: context.addRow,
              param1 : {},
              param2: columnId,
            };
            this.pendingActions.push(action);
          } else {
            context.addRow({},columnId);
          }
        } else {
          context.addRow();
        }
      }
    }
  };

  getAddRowsDataFromGroupedData = (
    groupingColumns,
    groupedData,
    outputRows,
    currentData = {},
    index = 0,
    currentLevelColIds = {}
  ) => {
    const nextIndex = index + 1;

    Object.keys(groupedData).forEach((key) => {
      let colIds = currentLevelColIds[key]["colId"];
      var outputAry = {};

      colIds.map((colId) => {
        currentData = { ...currentData };

        currentData[groupingColumns[index].field] = colId;
        if (isEmpty(groupedData[key])) {
          outputAry = this.getAddGroupedRowData(currentData, outputAry);
        }
      });
      if (isEmpty(groupedData[key])) {
        return outputRows.push(outputAry);
      }

      this.getAddRowsDataFromGroupedData(
        groupingColumns,
        groupedData[key],
        outputRows,
        currentData,
        nextIndex,
        currentLevelColIds[key]
      );
    });
  };

  setIsCheckBoxGroupDialogOpen = (val) => {
    this.isCheckBoxGroupDialogOpen = val;
  }

  toggleFloatingFilters = () => {
    this.isFloatingFiltersShown = !this.isFloatingFiltersShown;
    this.columnDefs.forEach(col => col.floatingFilter = col["header"] === "Id" ? false : this.isFloatingFiltersShown);
    this.gridApi.setColumnDefs(this.columnDefs)
  }

  getSortStringFromModel = (sortModel) => {
    const data = [];

    sortModel.forEach(dat => {
      data.push({
        property: this.columnDefs.find(col => col.colId == dat['colId']).dataIndex,
        direction: dat['sort']
      });
    })

    return data;
  }

  getCriteriaStringFromFilterModel(filterModel, ignoreColumnName = "") {
    const totalCriterias = [];

    // console.log(filterModel);
    // if (this.view?.criteria) {
    //   totalCriterias.push(this.view.criteria.query_string ?? this.view.criteria);
    // }

    Object.keys(filterModel).forEach(columnAliasPath => {
      const {
        values = [],
        valueString,
        searchText,
        filterType
      } = filterModel[columnAliasPath];
      const columnCriterias = [];

      if (searchText) {
        if(columnAliasPath !== "commentsId"){
          totalCriterias.push(this.getSearchCriteria(columnAliasPath, searchText));
        }
      }

      if (ignoreColumnName == columnAliasPath) {
        return;
      }

      if (valueString) {
        return totalCriterias.push(valueString);
      }

      if (filterType == "number") {
        let columnTypeId = '';
        for (let column of this.columns) {
          if(columnAliasPath === column?.alias_name || columnAliasPath === column?.alias_path) {
            columnTypeId = column?.column_type_id ?? '';
            break;
          }
        }
        totalCriterias.push(this.getNumberFilterCriteria(filterModel[columnAliasPath], columnAliasPath, columnTypeId));
      }

      values.forEach(value => {

        const criteria = this.getCriteria(columnAliasPath, value === NO_BLANKS ? "" : value || "", value === NO_BLANKS ? "!=" : "=");
        columnCriterias.push(criteria);
      })

      if (columnCriterias.length > 0) {
        totalCriterias.push(columnCriterias.length > 1 ? `( ${columnCriterias.join(" or ")} )` : columnCriterias[0])
      }
    })

    const quickSearchCriteria = this.getQuickSearchCriteria();
    if (quickSearchCriteria) {
      totalCriterias.push(quickSearchCriteria);
    }

    return totalCriterias.join(" and ");
  }

  getCriteria(columnAliasPath, value, operator = "=", value2 = "", columnTypeId = "") {
    if (value2) {
      if ((columnTypeId === '5' || columnTypeId === '17') && operator === 'BETWEEN') {
        return `${columnAliasPath} >= "${value.toString().replace(/"/g, "\"")}" AND ${columnAliasPath} <= "${value2}"`;
      }
      if (columnTypeId === '22' && operator === 'BETWEEN') {
        return `${columnAliasPath} >= ${(value/100).toString().replace(/"/g, "\"")} AND ${columnAliasPath} <= ${(value2/100).toString().replace(/"/g, "\"")}`;
      }
    }
    else {
      if (columnTypeId === '22') {
        return `${columnAliasPath} ${operator} ${(value/100).toString().replace(/"/g, "\"")}`;
      }
      return `${columnAliasPath} ${operator} "${value.toString().replace(/"/g, "\"")}"`;
    }
  }

  getSearchCriteria(columnAliasPath, value) {
    if(columnAliasPath === "Id"){ 
      return `${toUpperCamelCase(this.listConfig.list.name)}.id LIKE '${value.toString().replace(/"/g, "\"")}%' `
    }
    if (columnAliasPath !== "commentsId"){
      return ` ${columnAliasPath} LIKE '%${value.toString().replace(/"/g, "\"")}%' `
    }
  }

  getNumberFilterCriteria({ filterType, filter, filterTo, type, operator, condition1, condition2 }, columnAliasPath, columnTypeId = '') {
    const allCriterias = [];

    if (!operator) {
      const criteria = this.getCriteria(columnAliasPath, filter, this.getOperatorFromString(type), filterTo, columnTypeId);

      return `( ${criteria} )`
    }

    allCriterias.push(this.getCriteria(columnAliasPath, condition1.filter, this.getOperatorFromString(condition1.type), condition1.filterTo, columnTypeId))
    allCriterias.push(this.getCriteria(columnAliasPath, condition2.filter, this.getOperatorFromString(condition2.type), condition2.filterTo, columnTypeId))

    return `( ${allCriterias.join(` ${operator} `)} )`;
  }

  getOperatorFromString(type) {
    switch (type) {
      case "equal": return "=";
      case "notEqual": return "<>";
      case "lessThan": return "<";
      case "lessThanOrEqual": return "<=";
      case "greaterThan": return ">";
      case "greaterThanOrEqual": return ">=";
      case "inRange": return "BETWEEN";
      default: return "=";
    }
  }

  getQuickSearchCriteria() {
    const quickSearchCriteriaArray = [];

    if (this.quickSearchText) {
      this.columns.forEach(({ alias_path }) => {
        if (alias_path !== "commentsId"){
          quickSearchCriteriaArray.push(this.getSearchCriteria(alias_path, this.quickSearchText));
        }
      })
    }

    const criteria = quickSearchCriteriaArray.join(` or `);

    return criteria ? ` ( ${criteria} ) ` : "";
  }

  get allVisibleGridRowsCount() {
    if (!this.allSavedRowsCount) {
      this.allSavedRowsCount = this.allRowsData.length;
    }
    return this.allSavedRowsCount + this.newRows.length + 1 - this.addRowsDataLength;
  }

  get currentRowsCount() {
    const x = this.resetSavedRowsCount; //to trigger this function

    const newRowsCount = this.newRows.filter(newRow => newRow.row_id !== '').length;
    if (this.isGridGrouped) {
      return this.gridApi?.rowModel.rootNode?.allChildrenCount - this.addRowsDataLength;
    }

    if (this.shouldLoadAllRows) {
      const rowsToDisplay = this.gridApi?.rowModel.rowsToDisplay;
      const filteredRows = rowsToDisplay?.filter(row => {
        const rowId = row?.data?.row_id;
        return rowId !== '';
      });
      return filteredRows?.length - 1;
    }

    return this.allSavedRowsCount + newRowsCount;
  }

  onAgGridFilterChanged = ev => {
    this.currentFilterModel = this.gridApi.getFilterModel();

    if (!isEmpty(this.gridApi.getFilterModel())) {
      this.isGridFiltersActive = true;
    } else {
      this.isGridFiltersActive = false;
    }

    this.resetSavedRowsCount = !this.resetSavedRowsCount;
  };

  get isAnyColumnHidden() {
    return !!this.columnDefs.find((col) => col.hide === true);
  }

  get modified() {
    return this.isGridFiltersActive || this.isCriteriaModified || this.isAnyColumnHidden || this.isSortModified || this.isGroupModified || this.isNewColumnAdded;
  }

  get viewForSave() { 
    const view = cloneDeep(this.view);
    this.newColumns = this.newColumns.filter(col => col.alias_path !== "commentsId");
    if (this.newColumns.length > 0) {
      this.newColumns.forEach((col) => {
        view.options.columns.push(col);
      })
    }
    this.newColumns = [];
    if (this.isAnyColumnHidden) {
      const hiddenColumns = this.columnDefs.filter(col => col.isVisible === false);

      view.options.columns = view.options.columns.filter(col => !hiddenColumns.find(hiddenColDef => col.id === hiddenColDef.cellRendererParams.columnRaw.id));
    }

    if (this.isSortModified) {
      view.options.sorting = isEmpty(view.options.sorting) ? {} : view.options.sorting;
      view.options.sorting.columns = this.sorting.map(({ colId, sort }) => ({ key: colId, direction: sort }))
    }

    if (this.isGroupModified) {
      view.options.grouping = isEmpty(view.options.grouping) ? {} : view.options.grouping;
      view.options.grouping.columns = this.grouping.map((col) => ({
        key: col.colId,
        header: col.headerName,
        options: col.rowGroupOption,
      }));
      this.grouping.length === 0 && delete view.options.grouping;
    }

    let criteria = view.criteria.query_string;

    const criteriasList = [];

    if (criteria?.length > 0 && !this.isCriteriaModified) {
      criteriasList.push(criteria);
    }

    if (!isEmpty(this.modifiedCriteria) || !isEmpty(this.modifiedCriteria?.query_string)) {
      criteriasList.push(!isEmpty(this.modifiedCriteria.query_string) ? this.modifiedCriteria.query_string : this.modifiedCriteria);
    }

    if (this.isGridFiltersActive) {
      const filterModelCriteria = this.getCriteriaStringFromFilterModel(this.currentFilterModel)
      if (filterModelCriteria?.length > 0) {
        criteriasList.push(filterModelCriteria);
      }
    }

    if (criteriasList.length === 0 && this.isCriteriaModified) {
      view.criteria = "";
      return view;
    }
    if (criteriasList.length === 0) {
      return view;
    }
    if (criteriasList.length === 1) {
      view.criteria = criteriasList[0];
      return view;
    }

    const newCriteria = criteriasList.reduce((prevValue, curValue) => (`${this.encloseParanthesis(prevValue)} and ${this.encloseParanthesis(curValue)}`))
    view.criteria = newCriteria;
    return view;
  }

  encloseParanthesis(value) {
    const regExp = new RegExp(/^\(.+\)$/);
    const containsOrRegExp = new RegExp(/ or /);

    return regExp.test(value.trim()) || !containsOrRegExp.test(value.trim()) ? value : `( ${value} )`;
  }

  setModifiedCriteria(criteria) {
    if (this.resetCriteriaIfSame(criteria)) {
      return;
    }
    this.modifiedCriteria = criteria;
    this.isCriteriaModified = true;
  }

  resetCriteriaIfSame(newCriteria) {
    newCriteria.query_string && (newCriteria = newCriteria.query_string);
    if (newCriteria === this.view.criteria || newCriteria === this.view.criteria.query_string) {
      this.modifiedCriteria = "";
      this.isCriteriaModified = false;
      return true;
    }

    return false;
  }

  getViewCriteria() {
    if (!this.view) {
      return "";
    }
    if (this.isCriteriaModified) {
      return this.modifiedCriteria.query_string ?? this.modifiedCriteria;
    }
    const view = cloneDeep(this.view);
    return view.criteria.query_string;
  }

  get isSortModified() {
    return !!this.columnDefs.find(colDef => {
      const savedSortColumn = this.view?.options.sorting?.columns?.find(({ key }) => key === colDef["colId"])
      return savedSortColumn?.direction.toLowerCase() != colDef.sort;
    });
  }

  get isGroupModified() {
    return !!this.columnDefs.find(colDef => {
      const savedColumn = this.view?.options.grouping?.columns?.find(({ key }) => key === colDef["colId"])

      return (!!savedColumn && !colDef.rowGroup) || (!savedColumn && !!colDef.rowGroup);
    });
  }

  setDefaultSorting() {
    if (!this.isSortModified) {
      return;
    }
    this.columnDefs.forEach(columnDef => {
      const sortingColumns = this.view.options.sorting?.columns ? this.view.options.sorting?.columns : [];
      if (sortingColumns) {
        const sort = sortingColumns.find(({ key }) => key === columnDef["colId"]);
        columnDef.sort = sort?.direction.toLowerCase() ?? null
      }
    })
    this.setSorting();
  }

  setDefaultGrouping() {
    if (!this.isGroupModified) {
      return;
    }
    this.columnDefs.forEach((columnDef) => {
      const groupingColumns = this.view.options.grouping?.columns
        ? this.view.options.grouping?.columns
        : [];
      if (groupingColumns) {
        const groupIndex = groupingColumns.findIndex(
          ({ key }) => key === columnDef["colId"]
        );
        columnDef.rowGroup = groupIndex > -1 ? true : null;
        columnDef.rowGroupIndex = groupIndex > -1 ? groupIndex : null;
        columnDef.rowGroupOption =
          groupIndex > -1 ? groupingColumns[groupIndex].options : (columnDef.cellRendererParams?.columnTypeId == "4" || columnDef.cellRendererParams?.columnTypeId == "16" ? "my" :null);
        columnDef.keyCreator = (params) => {
          return this.getKeyCreatorValue(params, columnDef);
        }; //function (params) {return this.getKeyCreatorValue(params,columnDef) }
      }
    });
    this.redrawGridForGrouping(this.shouldLoadAllRows);
  }

  setSorting() {
    this.gridApi.setSortModel(this.sorting);
  }

  get sorting() {
    return this.columnDefs.filter(col => col.sort).sort((a, b) => a.sortIndex - b.sortIndex).map(({ colId, sort }) => ({ colId, sort }))
  }

  get grouping() {
    return this.columnDefs
      .filter((col) => col.rowGroup)
      .sort((a, b) => a.rowGroupIndex - b.rowGroupIndex);
  }

  async setDefaultColumns() {
    this.newColumns = [];
    this.hiddenColumns = [];
    this.isNewColumnAdded = false
    const resp = await this.fetchData();
    this.formatColumns(resp.data.columns);
    this.gridApi.setColumnDefs([]);
    this.gridApi.setColumnDefs(this.columnDefs);
    if (!this.isLazyLoadEnabled) {
      this.setAllRowsData(this.params);
    }
  }

  setColumnVisibility(column, isColumnVisible) {
    let index = this.columnDefs.findIndex(
      (col) => col.aliasPath === column.alias_path
    )
    if (isColumnVisible) {
      this.columnDefs[index]["isVisible"] = false;
      this.columnDefs[index]["hide"] = true;
      this.hiddenColumns.push(column.alias_path);
      this.gridApi.columnController.columnApi.setColumnVisible(
        column.alias_path,
        false
      );
    } else {
      this.columnDefs[index]["isVisible"] = true;
      this.columnDefs[index]["hide"] = false;
      if (this.hiddenColumns.indexOf(column.alias_path) >= 0) {
        this.hiddenColumns.splice(this.hiddenColumns.indexOf(column.alias_path), 1);
      }
      this.gridApi.columnController.columnApi.setColumnVisible(
        column.alias_path,
        true
      );
    }
    if (this.newColumns.length == 0) {
      this.isNewColumnAdded = false;
    }
  }

  showLookupColumnsInCurrentView = async (column) => {
    this.loadingColumns.add(column.alias_path);
    this.newColumns.push(column);
    this.isNewColumnAdded = true;
    this.gridApi.showLoadingOverlay();
    const resp = await this.fetchData();
    this.formatColumns(resp.data.columns);
    this.gridApi.setColumnDefs([]);
    this.gridApi.setColumnDefs(this.columnDefs);
    if (!this.isLazyLoadEnabled) {
      this.setAllRowsData(this.params);
    }
    if (this.newColumns.length == 0) {
      this.isNewColumnAdded = false;
    }
    this.gridApi.ensureColumnVisible("+");
    this.loadingColumns.delete(column.alias_path);
    return;
  }

  async resetView() {
    this.currentFilterModel = {};
    this.setFilterModel();
    if (this.isCriteriaModified) {
      this.modifiedCriteria = "";
      this.isCriteriaModified = false;
      await this.refreshData();
    }
    this.setDefaultSorting();
    this.setDefaultGrouping();
    if (this.isAnyColumnHidden) {
      this.columnDefs.forEach((col) => {
        if (col.isVisible !== false) {
          return;
        }
        delete col.isVisible;
        col.hide = false;
        this.gridApi.columnController.columnApi.setColumnVisible(
          col["colId"],
          true
        );
      });
      if(this.isCommentsColumnPrev != null && this.view?.options?.options?.is_comments_column_visible !== this.isCommentsColumnPrev){
        this.view.options.options.is_comments_column_visible = this.isCommentsColumnPrev;
        this.containerStore.view.options.options.is_comments_column_visible = this.isCommentsColumnPrev;
        this.isCommentsColumnPrev = null;
      }
    }
    this.hiddenColumns = [];
    this.setAgGridColumnDefs();
    if (this.isNewColumnAdded) {
      if(this.isCommentsColumnPrev != null && this.view?.options?.options?.is_comments_column_visible !== this.isCommentsColumnPrev){
        this.view.options.options.is_comments_column_visible = this.isCommentsColumnPrev;
        this.containerStore.view.options.options.is_comments_column_visible = this.isCommentsColumnPrev;
        this.isCommentsColumnPrev = null;
      }
      this.setDefaultColumns();
    }
  }

  setFilterModel = () => {
    this.currentFilterModel && this.gridApi.setFilterModel(this.currentFilterModel);
  };

  get shouldLoadAllRows() {
    return this.isSubsheet || !this.isLazyLoadEnabled || this.isGridGrouped;
  }

  get isGridGrouped() {
    return this.columnDefs.findIndex(col => col.rowGroup) !== -1;
  }

  parseQueryForTooltip = (event) => {
    let query = "", keys = {};
    try {
      let criteria = JSON.parse(event.criteria);
      query = criteria.query
      for (let i = 0; i < criteria.columns.length; i++) {
        let rhs = criteria.columns[i]["path"][1].alias_name
        for(let j=2; j<criteria.columns[i]["path"].length; j++) {
          rhs += "." + criteria.columns[i]["path"][j].alias_name
        }
        keys["column_" + i] = rhs
      }
      for (let key in keys) {
        query = query.replace(key, keys[key])
      }
      let loggedIdUserDetails = window.loggedInUserColumns
      for (let i = 0; i < loggedIdUserDetails.length; i++) {
        query = query.replace("LOGGED_IN_USER.column_" + loggedIdUserDetails[i]["column_id"], "LOGGED_IN_USER." + loggedIdUserDetails[i]["name"])
      }
    } catch (error) {
      // console.log(error);
    }
    return query
  }

  async fetchDataForSubsheet() {
    if (this.isSubsheetRowsLoaded) {
      return;
    }

    try {
      const listId = this.listId
      const resp = this.parentRowId
        ?
        await ApiClient.List.getRowData({
          list_id: this.parentListId,
          row_id: this.parentRowId,
          column_id: this.parentColumnId,
          paretn_column_id: this.parentColumnId,
          is_web: 1,
        })
        :
        {};
      const columns = this.columns;
      this.formatColumns(columns.filter(col => col.id !== "row_id"));

      if (!this.parentRowId) {
        this.allRowsData = this.data = this.formatSubsheetData(this.value); //todo check this.data
        return;
      }

      this.parentRow = resp.data;
      this.allRowsData = this.data = this.formatDataForGrid(resp.data?.[`column_${this.parentColumnId}`]); //todo check this.data
      this.isSubsheetRowsLoaded = true;
    } catch (e) {
      console.error(e);
    }
  }

  validateEmail(value) {
    const regularExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (regularExp.test(String(value).toLowerCase())) {
      return true;
    }
    return false;
  }

  validateUrl(value) {
    const regularExp = /^(https?:\/\/|rtsp:\/\/|ftp:\/\/)?(?!www\.[a-zA-Z0-9-]+$)(([a-zA-Z0-9][a-zA-Z0-9-]*\.)+[a-zA-Z]{2,}(:\d{1,5})?(\/\S*)?)$|^(https?:\/\/|rtsp:\/\/|ftp:\/\/)?www\.([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d{1,5})?(\/\S*)?$|^(https?:\/\/|rtsp:\/\/|ftp:\/\/)?((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])(:\d{1,5})?(\/\S*)?$/i;
    if (regularExp.test(String(value).trim())) {
      return true;
    }
    return false;
  }

  addConfigToColumnDefs(columnDefs) {
    return columnDefs.map((columnDef) => {
      columnDef.cellClassRules = {
        ...columnDef.cellClassRules,
        error: (...args) => {
          const params = args[0];
          if (!params.node.data) {
            return false;
          }
          const rowKey = params.node.data.uniqueId;
          const columnKey = params.colDef.field;
          const columnOptions = params.colDef.cellRendererParams.columnOptions;

          if (
            params.colDef?.cellRendererParams?.columnTypeId === "14" &&
            params.value &&
            params.value !== "" &&
            params.value !== "+r0w" &&
            params.value !== "+" &&
            !this.validateEmail(params.value)
          ) {
            return true;
          }

          if (
            params.colDef?.cellRendererParams?.columnTypeId == "24" &&
            params.value &&
            params.value !== "" &&
            params.value !== "+r0w" &&
            params.value !== "+" &&
            !this.validateUrl(params.value)
          ) {
            return true;
          }

          if (params.data.row_id == "+" || !rowKey) {
            return false;
          }

          if (columnOptions?.is_mandatory && !params.value) {
            return true;
          }

          if (params.value && columnOptions?.min_length && columnOptions.min_length > params.value?.toString().length) {
            return true;
          }

          if (params.value && columnOptions?.max_length && columnOptions.max_length < params.value?.toString().length) {
            return true;
          }

          if (
            params.value &&
            columnOptions?.max_value &&
            Number(columnOptions.max_value) < Number(params.value)
          ) {
            return true;
          }

          if (
            params.value &&
            columnOptions?.min_value &&
            Number(columnOptions.min_value) > Number(params.value)
          ) {
            return true;
          }

          if (!this.cellMetaData[rowKey]?.[columnKey]) {
            return false;
          }

          if (this.cellMetaData[rowKey]?.[columnKey]?.isError) {
            return true;
          } else if (this.cellMetaData[rowKey]?.[columnKey]?.isSaving) {
            // return { ...style, 'border-left': '4px solid #339FFF' }
          }
          return false;
        },
        checkbox_cell_inline_editing: (params) => {
          const columnTypeId = params.colDef.cellRendererParams.columnTypeId;

          return columnTypeId == 13
        },
        file_cell_inline_editing: (params) => {
          const columnTypeId = params.colDef.cellRendererParams.columnTypeId;

          return columnTypeId == 9
        },
        subsheet_cell_inline_editing: (params) => {
          const columnTypeId = params.colDef.cellRendererParams.columnTypeId;

          return columnTypeId == 6
        },
        boolean_cell_inline_editing: (params) => {
          const columnTypeId = params.colDef.cellRendererParams.columnTypeId;

          return columnTypeId == 12
        },
        multiline_cell_inline_editing: (params) => {
          const columnTypeId = params.colDef.cellRendererParams.columnTypeId;

          return columnTypeId == 8
        },
        comments_cell_inline_editing: (params) =>{
          const columnTypeId = params.colDef.cellRendererParams.columnTypeId;

          return columnTypeId == "comments_id"
        },
        star_cell_inline_editing: (params) =>{
          const columnTypeId = params.colDef.cellRendererParams?.columnOptions?.is_star_column;

          return columnTypeId == true
        }
      }

      columnDef.cellEditorParams = {
        ...(columnDef.cellEditorParams || {}),
        cellMetaData: this.cellMetaData,
      };

      columnDef.cellRendererParams.cellMetaData = this.cellMetaData;
      if (this.isSubsheet) {
        columnDef.cellRendererParams.isSubsheet = this.isSubsheet;
      }
      columnDef.cellRendererParams.store = this;
      columnDef.cellRendererParams.listId = this.listId;
      columnDef.filterParams = {
        ...columnDef.filterParams,
        defaultToNothingSelected: true,
        refreshValuesOnOpen: true,
        suppressSelectAll: true,
        // suppressMiniFilter: true,
        values: this.getFilterValues,
        buttons: ['reset']
      }

      if (columnDef.filter == "agNumberColumnFilter") {
        columnDef.filterParams = {
          ...columnDef.filterParams,
          filterOptions: [
            {
              displayKey: "equal",
              displayName: "Equals",
              test: (filterValue, cellValue) => {
                if (!isNaN(cellValue) && columnDef?.cellRendererParams?.columnTypeId == "22" ) {
                  let decimals = String(cellValue).includes(".") ? String(cellValue).split(".")[1].length : 2
                  cellValue = (cellValue * 100).toFixed(decimals - 2)
                }
                return filterValue == null
                  ? false
                  : parseFloat(cellValue) === filterValue;
              },
            },
            {
              displayKey: "notEqual",
              displayName: "Not Equals",
              test: (filterValue, cellValue) => {
                if (!isNaN(cellValue) && columnDef?.cellRendererParams?.columnTypeId == "22" ) {
                  let decimals = String(cellValue).includes(".") ? String(cellValue).split(".")[1].length : 2
                  cellValue = (cellValue * 100).toFixed(decimals - 2)
                }
                return filterValue == null
                  ? false
                  : parseFloat(cellValue) !== filterValue;
              },
            },
            {
              displayKey: "lessThan",
              displayName: "Less Than",
              test: (filterValue, cellValue) => {
                if (!isNaN(cellValue) && columnDef?.cellRendererParams?.columnTypeId == "22" ) {
                  let decimals = String(cellValue).includes(".") ? String(cellValue).split(".")[1].length : 2
                  cellValue = (cellValue * 100).toFixed(decimals - 2)
                }
                return filterValue == null
                  ? false
                  : parseFloat(cellValue) < filterValue;
              },
            },
            {
              displayKey: "lessThanOrEqual",
              displayName: "Less Than or Equal",
              test: (filterValue, cellValue) => {
                if (!isNaN(cellValue) && columnDef?.cellRendererParams?.columnTypeId == "22" ) {
                  let decimals = String(cellValue).includes(".") ? String(cellValue).split(".")[1].length : 2
                  cellValue = (cellValue * 100).toFixed(decimals - 2)
                }
                return filterValue == null
                  ? false
                  : parseFloat(cellValue) <= filterValue;
              },
            },
            {
              displayKey: "greaterThan",
              displayName: "Greater Than",
              test: (filterValue, cellValue) => {
                if (!isNaN(cellValue) && columnDef?.cellRendererParams?.columnTypeId == "22" ) {
                  let decimals = String(cellValue).includes(".") ? String(cellValue).split(".")[1].length : 2
                  cellValue = (cellValue * 100).toFixed(decimals - 2)
                }
                return filterValue == null
                  ? false
                  : parseFloat(cellValue) > filterValue;
              },
            },
            {
              displayKey: "greaterThanOrEqual",
              displayName: "Greater Than or Equal",
              test: (filterValue, cellValue) => {
                if (!isNaN(cellValue) && columnDef?.cellRendererParams?.columnTypeId == "22" ) {
                  let decimals = String(cellValue).includes(".") ? String(cellValue).split(".")[1].length : 2
                  cellValue = (cellValue * 100).toFixed(decimals - 2)
                }
                return filterValue == null
                  ? false
                  : parseFloat(cellValue) >= filterValue;
              },
            },
            {
              displayKey: "inRange",
              displayName: "In Range",
              test: (filterValue, cellValue) => {
                if (!isNaN(cellValue) && columnDef?.cellRendererParams?.columnTypeId == "22" ) {
                  let decimals = String(cellValue).includes(".") ? String(cellValue).split(".")[1].length : 2
                  cellValue = (cellValue * 100).toFixed(decimals - 2)
                }
                var customfilterModel = this.gridApi.getFilterModel();
                var currentDateFilter = customfilterModel[columnDef["colId"]];
                return currentDateFilter.filter == null
                  ? false
                  : parseFloat(cellValue) >= currentDateFilter.filter &&
                      parseFloat(cellValue) <= currentDateFilter.filterTo;
              },
            },
          ],
        };
      }
      if (
        columnDef.cellRendererParams?.columnOptions?.is_read_only == true ||
        columnDef.cellRendererParams?.columnTypeId === "19" ||
        columnDef.cellRendererParams?.columnTypeId === "7" ||
        columnDef.cellRendererParams?.columnTypeId === "6"
      ) {
        columnDef.suppressPaste = true;
      }

      if (this.hiddenColumns.length > 0) {
        this.hiddenColumns.forEach((hiddenColumn) => {
          if (columnDef.aliasPath == hiddenColumn) {
            columnDef.hide = true;
          }
        })
      }
      const sortingColumns = this.view?.options.sorting?.columns;
      if (sortingColumns) {
        const sort = sortingColumns.find(({ key }) => key === columnDef["colId"]);
        sort && (columnDef.sort = sort.direction.toLowerCase())
      }

      const groupingColumns = this.view?.options.grouping?.columns;
      if (groupingColumns) {
        const groupIndex = groupingColumns.findIndex(({ key }) => key === columnDef["colId"]);
        if (groupIndex > -1) {
          columnDef.rowGroup = true;
          columnDef.rowGroupIndex = groupIndex;
          columnDef.rowGroupOption = groupingColumns[groupIndex].options;
          columnDef.keyCreator = (params) => {
            return this.getKeyCreatorValue(params, columnDef);
          }; //function (params) {return this.getKeyCreatorValue(params,columnDef) }
        }
      }

      columnDef.getQuickFilterText = (params) => {
        if (params.column.colDef.cellRendererParams.columnTypeId === "9") {
          return "";
        }

        if (params.data.row_id === "+" || !params.data.row_id) { //HACK to show add row and new rows in quick search;
          return this.quickSearchText;
        }

        if (params?.column?.colDef?.cellRendererParams?.columnTypeId === "22" && params.value ) {
          let decimals = String(params.value).includes(".") ? String(params.value).split(".")[1].length : 2
          return (params.value*100).toFixed(decimals-2)
        }

        if (params?.column?.colDef?.cellRendererParams?.columnTypeId === "10" && params.value ) {
          if (params.column.colDef.cellRendererParams?.columnOptions?.column_type === "percentage") {
            let decimals = String(params.value).includes(".") ? String(params.value).split(".")[1].length : 2
            return (params.value*100).toFixed(decimals-2)
          }
        }
        
        return params.value;
      }

      columnDef.store = this;
      return columnDef;
    });
  }

  getFilterValues = async (params) => {
    const columnId = params?.colDef?.field;
    let acc = {};
    if (this.isSubsheet) {
      try {
        if (this.shouldLoadAllRows) {
          this.gridApi.forEachNode(function (rowNode) {
            if (params.doesRowPassOtherFilter(rowNode)) {
              const row = rowNode.data;
              if (!row || row[columnId] === "+r0w" || row[columnId] == undefined) {
                return;
              }
              acc[row[columnId]] = acc[row[columnId]] ?? 0;
              acc[row[columnId]]++;
            }
          });
          return Object.entries(acc).map(([key, count]) => { return { [columnId]: key, count } })
        } else {
          return params.success?.([]) ?? [];
        }  
      } catch (e) {
        return params.success?.([]) ?? [];
      }
    }

    try {
      if (this.shouldLoadAllRows) {
        if (this.modified) {
          this.gridApi.forEachNode(function (rowNode) {
            if (params.doesRowPassOtherFilter(rowNode)) {
              const row = rowNode.data;
              if (!row || row[columnId] === "+r0w") {
                return;
              }
              acc[row[columnId]] = acc[row[columnId]] ?? 0;
              acc[row[columnId]]++;
            }
          });
        } else {
          acc = this.allRowsData.reduce((acc, row) => {
            acc[row[columnId]] = acc[row[columnId]] ?? 0;
            acc[row[columnId]]++;

            return acc;
          }, {});
          const newRowsData = this.newRows.map(row => row[columnId]);
            newRowsData.forEach(key => {
                acc[key] = acc[key] ?? 0;
                acc[key]++;
            });
        }

        return Object.entries(acc).map(([key, count]) => { return { [columnId]: key, count } })
      }

      let data = await ApiClient.List.getColumnUniqueData({
        list_id: this.listId,
        column_id: columnId,
        view_id: this.viewId,
        search: this.getCriteriaStringFromFilterModel(this.currentFilterModel || {}, params.colDef.colId),
        limit: 50000
      });
      data = data.data;
      // data = data.map(dat => dat[columnId])
      return params.success?.(data) ?? data;
    } catch (e) {
      console.log(e);
      // window.alert(e.message);
    }
  }

  async saveRowForm(e, data, rowIndex) {
    const columnKey = e.colDef.field;
    if (this.cellMetaData[rowIndex]?.isSaving) {
      this.pendingApiCalls[rowIndex] = this.pendingApiCalls[rowIndex] || [];
      this.pendingApiCalls[rowIndex].push({ e });
      // console.log(this.pendingApiCalls);
      return false;
    }

    this.updateCellMetaData(e, rowIndex, columnKey, true, true);

    if (!this.validateMandatoryColumns(e, data, rowIndex, columnKey)) {
      this.handleEvents(e);
      return;
    }

    const reqData = this.getFormDataFormatted(data);
    try {
      this.currentApiCallsCount++;
      const resp = await ApiClient.List.saveRowForm({
        list_id: this.parentListId ?? this.listId,
        data: JSON.stringify(reqData),
      });
      this.currentApiCallsCount--;
      this.isCurrentRowSaving = false;

      this.showErrors(e, rowIndex, false);

      this.callPendingApis(rowIndex, resp.row_id);
      return resp.row;
    } catch (error) {
      this.currentApiCallsCount--;
      this.isCurrentRowSaving = false;

      this.showErrors(error, rowIndex, true, error?.response?.errors?.[0] || "something went wrong");

      throw error;
    }
  }

  updateCellMetaData(e, rowIndex, columnKey, isSaving = true, shouldUpdateRow = false) {
    this.cellMetaData[rowIndex] = this.cellMetaData[rowIndex] || {};

    if (shouldUpdateRow) {
      this.cellMetaData[rowIndex].isSaving = isSaving;
    }

    this.cellMetaData[rowIndex][columnKey] = this.cellMetaData[rowIndex][columnKey] || {};
    this.cellMetaData[rowIndex][columnKey].isSaving = isSaving;
    // console.log(JSON.stringify(this.cellMetaData[rowIndex]));
    e.api.refreshCells({
      rowNodes: [e.node],
      force: true,
    });
  }

  validateMandatoryColumns(e, data, rowIndex, columnKey, isSubsheet = false) {
    if (!this.mandatoryColumns) return true;
    for (let i = 0; i < this.mandatoryColumns.length; i++) {
      const column = this.mandatoryColumns[i];
      if (!data[column["dataIndex"]] && (!isSubsheet || ((isSubsheet && data.row_id == "") || (isSubsheet && window.LOGGED_IN_USER.domain == "samberry2" && columnKey == "column_9575")))) {
        this.cellMetaData[rowIndex][columnKey].isSaving = false;
        this.cellMetaData[rowIndex][columnKey].isError = true;
        this.cellMetaData[rowIndex][columnKey].hoverMessage = "Please fill all mandatory columns to save.";

        e.api.refreshCells({
          rowNodes: [e.node],
          force: true,
        });
        this.cellMetaData[rowIndex].isSaving = false;
        return false;
        // throw new Error(`Mandatory Columns are not filled`); // or return false;
      }
    }
    return true;
  }

  showErrors(e, rowIndex, shouldShow = true, error = "") {
    this.cellMetaData[rowIndex].isSaving = false;

    Object.keys(this.cellMetaData[rowIndex]).forEach((columnId) => {
      if (typeof this.cellMetaData[rowIndex][columnId] != "object") {
        return;
      }

      this.cellMetaData[rowIndex][columnId]["isSaving"] = false;
      this.cellMetaData[rowIndex][columnId]["isError"] = shouldShow;
      this.cellMetaData[rowIndex][columnId]["hoverMessage"] = error;
    });

    e.api?.refreshCells({
      rowNodes: [e.node],
      force: true,
    });
  }

  getFormDataFormatted(data, isOnlyCurrentRow = false, shouldSendOnlyIfModified = false) {
    const reqData = {};
    let isRowModified = false;

    this.columnsFormatted.forEach((col) => {
      const columnTypeId = col.column_type_id;
      let value = data[col.dataIndex];
      let options = col.options;
      if(options?.["is_read_only"] || options?.["is_star_column"]){
        return;
      }
      if ((columnTypeId == 10 || columnTypeId == 9)) {
        if (!value && columnTypeId == 10) {
          value = { reference_column_id: null, value: "" };
        }

        if (!value && columnTypeId == 9) {
          value = [];
        }
        value = JSON.stringify(value);
      }
      if (columnTypeId == 6 && typeof value != "object") {
        return;
      }
      let columnsTypeIds = ["1", "14", "8", "20", "5", "17", "4", "16", "3", "13", "11", "18", "24"]
      if (!value && columnsTypeIds.includes(columnTypeId)) {
        value = ""
      } else if (!value && columnTypeId == 22) {
        value = ""
      } else if (!value && columnTypeId == 12) {
        value = false
      } 
      const isModified = columnTypeId != 7 && columnTypeId != 19 && col.is_default != 1 && col.default_type != 1 && col.alias_name != "createdBy" && (this.isSubsheet ? (data[col.dataIndex + "_isModified"] ?? false) : (this.containerStore.permissions?.canAddColumn(col.id)[0] ?? true));
      isRowModified = isRowModified || isModified;
      reqData[col.id] = {
        value: value,
        column_type_id: columnTypeId,
        row_id: "",
        alias_name: col.alias_name,
        is_modified: isModified,
      };

      if (columnTypeId == 6) {
        reqData[col.id].sub_list_id = col.options.sub_list_id;
      }
    });

    if (this.isSubsheet && !isOnlyCurrentRow) {
      return {
        [this.parentColumnId]: {
          is_modified: true,
          column_type_id: 6,
          value: [reqData],
          row_id: this.parentRowId,
          sub_list_id: this.listId
          // alias_name:
        }
      }
    }

    return shouldSendOnlyIfModified && !isRowModified ? false : reqData;
  }

  async callPendingApis(rowKey, rowId) {
    if (this.pendingApiCalls[rowKey]) {
      const apis = this.pendingApiCalls[rowKey];
      this.pendingApiCalls[rowKey] = [];
      apis.forEach((api) => {
        this.handleCellValueChanged(api.e, rowId);
      });
    }
  }

  async addEditCell(e, row_id, column_id, value, columnTypeId, rowIndex, isNewRowInSubsheet = false, fromRowDetailPanel = false, column = {}) {
    if (columnTypeId == 10) {
      value = JSON.stringify(value);
    }
    if (parseInt(columnTypeId) === 15 && !value) {
      return;
    }
    try {
      this.updateCellMetaData(e, rowIndex, "column_" + column_id, true);

      if (this.isSubsheet) {
        const isAllMandatoryColumnsFilled = this.validateMandatoryColumns(e, e.node.data, rowIndex, fromRowDetailPanel ? 'column_' + column_id : e.colDef.field, this.isSubsheet);

        if (isAllMandatoryColumnsFilled && !this.parentRowId) {
          this.showErrors(e, rowIndex, true, "Please fill MAIN ROW mandatory columns to save");
        }
        if (!isAllMandatoryColumnsFilled || !this.parentRowId) {
          this.handleEvents(e);
          return;
        }
      }

      this.currentApiCallsCount++;
      const resp = await ApiClient.List.addEditCell({
        list_id: this.listId,
        row_id: row_id,
        column_id: column_id,
        value: value,
        parent_row_id: this.parentRowId ?? 0,
        parent_list_id: this.parentListId ?? 0,
        parent_column_id: this.parentColumnId ?? 0,
        is_web: 1,
      });
      this.currentApiCallsCount--;
      this.isCurrentRowSaving = false;

      if (this.isSubsheet && !row_id) {
        this.showErrors(e, rowIndex, false);
      } else {
        if (resp.warnings.length) {
          this.cellMetaData[rowIndex]["column_" + column_id].isError = true;
          this.cellMetaData[rowIndex]["column_" + column_id].isSaving = true;
          this.cellMetaData[rowIndex]["column_" + column_id].hoverMessage =
            resp.warnings[0].error;
        } else {
          this.cellMetaData[rowIndex]["column_" + column_id].isError = false;
          this.cellMetaData[rowIndex]["column_" + column_id].isSaving = false;
          this.cellMetaData[rowIndex]["column_" + column_id].hoverMessage = "";
        }

        e.api.refreshCells({
          rowNodes: [e.node],
          force: true,
        });
      }
      const isFilling = e?.isFilling ? true : false;
      const isPasting = e?.source ? e.source === "paste" : false;

      if (!isPasting && !isFilling) {
        this.refreshGroupedColHeaderWhileUpdation(e.node);
      }

      if (resp.success && ((!isPasting && !isFilling) || (isPasting && isNewRowInSubsheet) || (isFilling && isNewRowInSubsheet))) {
        if (this.isSubsheet && resp.data && Object.keys(resp.data).length > 0 && !row_id) {
          resp.data['uniqueId'] = e.node.data.uniqueId ?? resp.data['row_id'];
          if (resp.data.subsheet_row_id) {
            delete resp.data['subsheet_row_id'];
          }
          handleUpdatingData('', JSON.stringify([resp.data]), this.listId, this.isSubsheet);
        } else {
          var nodeData = {};
          resp.data['uniqueId'] = e.node.data.uniqueId ?? resp.data['row_id'];
          const columnName = fromRowDetailPanel ? (column.name ?? column.alias_name) : (e?.colDef?.cellRendererParams?.columnRaw?.name ?? e?.colDef?.cellRendererParams?.columnRaw?.alias_name);
          const columnPath = fromRowDetailPanel ? column.alias_path : e.colDef.aliasPath;
          nodeData[resp.data.row_id] = [resp?.data ? resp.data : {}, {'columnName': columnName ?? '', 'columnPath': columnPath}];
          if (resp.data && Object.keys(resp.data).length > 0 && nodeData[resp.data.row_id].length > 0) {
            handleUpdatingData(JSON.stringify(nodeData), '', this.listId, this.isSubsheet);
          }
        }
      }

      resp.errorDetails = this.cellMetaData[rowIndex]["column_" + column_id];
      return fromRowDetailPanel ? resp : resp.data;
    } catch (error) {
      this.currentApiCallsCount--;
      this.isCurrentRowSaving = false;

      this.cellMetaData[rowIndex]["column_" + column_id].isSaving = false;
      this.cellMetaData[rowIndex]["column_" + column_id].isError = true;
      this.cellMetaData[rowIndex]["column_" + column_id].hoverMessage =
        error?.response?.errors?.[0] ?? error?.response?.msg ?? "something went wrong";
      console.log(
        JSON.stringify(this.cellMetaData[rowIndex]["column_" + column_id])
      );
      e.api.refreshCells({
        rowNodes: [e.node],
        force: true,
      });

      if (fromRowDetailPanel) {
        return {success: false, errorDetails: this.cellMetaData[rowIndex]["column_" + column_id]};
      }
      throw error;
    }

    // console.log(this.cellMetaData[rowIndex]["column_" + column_id])
  }

  getRowNodeById(rowId, uniqueId = '') {
    try {
      let matchedRowIdx = '';
      // let targetNode = this.gridApi.getRowNode(rowId) ?? this.gridApi.getRowNode(uniqueId);
      let targetNode = this.gridApi.getRowNode(rowId);
      if (!targetNode) {
        matchedRowIdx = this.newRows.findIndex(row => rowId == row.row_id);
        if (matchedRowIdx >= 0) {
          const matchedRowUniqueId = this.newRows[matchedRowIdx].uniqueId;
          targetNode = this.gridApi.getRowNode(matchedRowUniqueId);
        }
      }

      return {'node': targetNode, 'matchedRowIdx': matchedRowIdx}; 
    } catch (error) {
        console.log('Error: ', error);
    }
  }

  refreshGroupedColHeaderWhileUpdation(node) {
    try {
      if (this.isGridGrouped && node && node?.parent) {
        this.gridApi.redrawRows({rowNodes: [node.parent]});
      }
    } catch (e) {
      console.log('Error in Grouped Refresh', e);
    }
  }

  modifyDuplicatesDataCount (columnId, value, isNewValue, currentRowId, subsheetColumnId = '', shouldRefresh = true) {
    try {
      if (['5', '17', '22'].includes(this.duplicateColumnsConfigs[columnId]?.column_type_id) && isNewValue) {
        var decimalCount = Number(this.duplicateColumnsConfigs[columnId]?.options?.decimals) ?? 0;
        var decimalCountOfValue = value.toString().includes('.') ? value.toString().split('.')[1].length : 0;
        if (decimalCount > 0 && decimalCountOfValue !== decimalCount) {
          value = Number(value).toFixed(decimalCount).toString();
        }
      }
      if(isNewValue) {
        if (!this.duplicateColumnsData[columnId][value] || this.duplicateColumnsData[columnId][value] == 0) {
          this.duplicateColumnsData[columnId][value] = 1;
        }
        else if (this.duplicateColumnsData[columnId][value] > 0) {
          this.duplicateColumnsData[columnId][value] = this.duplicateColumnsData[columnId][value] + 1;
        }
        if (this.duplicateColumnsData[columnId][value] == 2 && shouldRefresh) {
          this.redrawRefreshedRows(subsheetColumnId !== '' ? subsheetColumnId : columnId, value, currentRowId, true);
        }
      } else {
        if (this.duplicateColumnsData[columnId][value] && this.duplicateColumnsData[columnId][value] > 0) {
          this.duplicateColumnsData[columnId][value] = this.duplicateColumnsData[columnId][value] - 1;
        }
        if (this.duplicateColumnsData[columnId][value] == 1 && shouldRefresh) {
          this.redrawRefreshedRows(subsheetColumnId !== '' ? subsheetColumnId : columnId, value, currentRowId, true);
        }
      }
    } catch (e) {
      console.log('Error', e);
    }
  }
  
  modifyDuplicatesCountWhenCellValueChanged (columnTypeId, newValue, oldValue, currCellColumnId, isHighlighted, subsheetColumnId = '', oldRowData, newRowData, isSubsheet = false) {
    try {
      if (this.isValidCellValue(columnTypeId, newValue) && isHighlighted) {
        this.modifyDuplicatesDataCount(currCellColumnId, newValue, true, newRowData?.row_id, subsheetColumnId);
      }
      if (this.isValidCellValue(columnTypeId, oldValue) && isHighlighted) {
        this.modifyDuplicatesDataCount(currCellColumnId, oldValue, false, newRowData?.row_id, subsheetColumnId);
      }
      if (Object.keys(this?.duplicateColumnsData).length > 1) {
        const highlightedColumnIds = Object.keys(this.duplicateColumnsData);
        highlightedColumnIds.forEach(columnId => {
          if (columnId !== "themeColor" && columnId !== currCellColumnId) {
            const column_Id = !isSubsheet ? columnId : columnId.slice(0, columnId.lastIndexOf('_'));
            let newValue = newRowData[column_Id];
            let oldValue = oldRowData[column_Id];
            if(this.duplicateColumnsConfigs[column_Id]?.column_type_id == "4" || this.duplicateColumnsConfigs[column_Id]?.column_type_id == "16"){
              newValue = this.formatDateTimeValue(newValue);
              oldValue = this.formatDateTimeValue(oldValue);
            }
            if (this.isValidCellValue(this.duplicateColumnsConfigs[column_Id]?.column_type_id, newValue) && newValue !== oldValue) {
              this.modifyDuplicatesDataCount(columnId, newValue, true, newRowData?.row_id, isSubsheet ? column_Id : '');
            }
            if (this.isValidCellValue(this.duplicateColumnsConfigs[column_Id]?.column_type_id, oldValue) && newValue !== oldValue) {
              this.modifyDuplicatesDataCount(columnId, oldValue, false, newRowData?.row_id, isSubsheet ? column_Id : '');
            }
          }
        });
      }
    } catch(e) {
      console.log("Error", e);
    }
  }

  formatDateTimeValue (value) {
    var formattedValue = value ? value.includes('T') ? value.replace('T', ' ') : value : '';
    return (formattedValue && formattedValue.match(/^\d{4}-\d{2}-\d{2}$/) && (formattedValue !== "0000-00-00" && formattedValue !== "0000-00-00 00:00:00")) ? formattedValue + " 00:00:00" : formattedValue;      
  }

  isValidCellValue (columnTypeId, value) {
    return (["5", "17", "22"].includes(columnTypeId) && Number(value) && Number(value) !== 0)
    || (["4", "16"].includes(columnTypeId) && value !== "0000-00-00 00:00:00" && value !== "0000-00-00" && value)
    || (["1", "8", "14", "20"].includes(columnTypeId) && value !== "");
  }
  async refreshStarCell(colId, value, node) {
    node.data[colId] = value;
    node.setData(node.data);
  }

  async handleCellValueChanged(e, rowId) {
    if(e.colDef.cellRendererParams.columnTypeId === "comments_id"){
      return;
    }
    let newValue = e.newValue;
    let oldValue = e.oldValue;
    const rowKey = e.node.data.uniqueId;
    const columnKey = e.colDef.field;
    const columnId = e.colDef.cellRendererParams.columnId;
    const columnTypeId = e.colDef.cellRendererParams.columnTypeId;
    let previousValue = e.node.data[e.colDef['dataIndex']];

    if(e.colDef?.cellRendererParams?.columnOptions?.is_read_only){
      window.appStore.notificationStore.showNotification(
        "Cannot modify read only fields.",
        "error"
      );
      return;
    }

    if (
      this.view?.type == "table" &&
      this.view?.list_id &&
      this.view?.options?.main_list_id &&
      this.view?.list_id != this.view?.options?.main_list_id
    ) {
      return;
    }

    if( columnTypeId == 1 || columnTypeId == 8 ) {
      if( e.colDef.cellRendererParams.columnOptions.trim_white_spaces != undefined && e.colDef.cellRendererParams.columnOptions.trim_white_spaces) {
        newValue = newValue.trim()
      }
    }
    if ((columnTypeId == 5 || columnTypeId == 17 || columnTypeId == 22) && e.source === "paste") {
      newValue = newValue?.replace(/[,]/g, "");
    }
    let cellOldValue = (e.isFilling && e.previousValue) ? e.previousValue : oldValue;
    if ((columnTypeId == 5 || columnTypeId == 17) && newValue && cellOldValue && Number(newValue) == Number(cellOldValue)) {
      return;
    }
    if(columnTypeId == 22){
      if(cellOldValue){
        let decimals = String(cellOldValue).includes('.') ? String(cellOldValue).split(".")[1].length : 2        
        if(Number(newValue).toFixed(decimals) == Number(cellOldValue).toFixed(decimals)){
          return;
        }
      }
    } 
    if (e.source && e.source === "paste") {
      this.isPasteSuccess = true;
    }
    rowId = rowId ?? e.node.data.row_id;

    if (columnTypeId == 6 && rowId) {
      e.node.data[columnKey] = "loading...";
      e.node.setData(e.node.data);
      await this.fetchRowData(e, rowId);
      this.refreshRowForColoring(e.node);
      // todo get subsheet count from backend;
      return; // already saved inside subsheet
    }
    // if (this.isSubsheet) {
    e.node.data[columnKey] = newValue;
    e.node.data[columnKey + "_isModified"] = true;
    e.node.data.isModified = true;
    //   this.handleEvents(e);
    //   return;
    // }

    if (e.colDef.cellRendererParams.columnTypeId == 12) {
      newValue = newValue == 1 ? true : false;
    }

    const rowData = e.node.data;
    if (rowId && !rowData.row_id) {
      rowData.row_id = rowId;
    }
    if (!rowData.row_id && !this.isSubsheet) {
      try {
        const respData = await this.saveRowForm(e, e.node.data, rowKey);
        if (!respData) {
          return;
        }

        Object.keys(respData).forEach((columnId) => {
          e.node.data[columnId] = respData[columnId];
        });
       
        if(!e.node.data["comments"]){
          e.node.data["comments"] = [];
        }
        e.node.setData(e.node.data);
        handleUpdatingData('', JSON.stringify([e.node.data]), this.listId, this.isSubsheet);
        this.duplicateRowsThatNeedCountUpdation[rowKey] = {...e.node?.data};
        this.refreshGroupedColHeaderWhileUpdation(e.node);

        try {
          if (Object.keys(this?.duplicateColumnsData).length > 1 && this.duplicateRowsThatNeedCountUpdation.hasOwnProperty(rowKey) && Object.keys(this.duplicateRowsThatNeedCountUpdation[rowKey]).length > 0) {
            const highlightedColumnIds = Object.keys(this.duplicateColumnsData);
            highlightedColumnIds.forEach(columnId => {
              if (columnId !== "themeColor") {
                let formattedNewValue =this.duplicateRowsThatNeedCountUpdation[rowKey][columnId] ?? '';
                if(this.duplicateColumnsConfigs[columnId]?.column_type_id == "4" || this.duplicateColumnsConfigs[columnId]?.column_type_id == "16"){
                  formattedNewValue = this.formatDateTimeValue(formattedNewValue);
                }
                if (this.isValidCellValue(this.duplicateColumnsConfigs[columnId]?.column_type_id, formattedNewValue)) {
                  this.modifyDuplicatesDataCount(columnId, formattedNewValue, true, e.node?.data?.row_id);
                }
                this.duplicateRowsThatNeedCountUpdation[rowKey][columnId + '_is_deleted'] = true;
              }
            });
          }
        } catch (e) {
          console.log('Error', e);
        }
        this.refreshRowForColoring(e.node, e?.source || "");
        if(this.isLazyLoadEnabled) {
          this.executePendingActions();
        }
        this.resetSavedRowsCount = !this.resetSavedRowsCount;   
      } catch (error) {
        console.log(error);
      }
      return;
    }
       
    try {
      const isNewRowInSubsheet = !rowId && this.isSubsheet ? true : false;
      const valueData = rowId ? newValue : this.getFormDataFormatted(e.node.data, true);
      const respData = await this.addEditCell(e, rowId, columnId, valueData, columnTypeId, rowKey, isNewRowInSubsheet);
      if (!respData) {
        return;
      }
      let oldRowNodeData = {...e.node.data};
      Object.keys(respData).forEach((columnId) => {
        e.node.data[columnId] = respData[columnId];
      });
      e.node.setData(e.node.data);

      try {
        if(columnTypeId == "4" || columnTypeId == "16"){
          previousValue = this.formatDateTimeValue(previousValue);
        }

        let handleFillCellsOldValue = (e.isFilling && e.previousValue) ? e.previousValue : oldValue;
        if (e.colDef.cellRendererParams.columnOptions?.is_highlighted && newValue == "" && handleFillCellsOldValue == "" && e?.is_deleted && previousValue !== "" && this.isValidCellValue(columnTypeId, previousValue)){
          if(!this.isSubsheet){
            this.modifyDuplicatesDataCount(e.colDef.dataIndex, previousValue, false, e.node.data?.row_id);
          }
          else {
            this.modifyDuplicatesDataCount(e.colDef.dataIndex + '_' + this.parentRowId, previousValue, false, e.node.data?.row_id, e.colDef.dataIndex);
          }
        }

        if(Object.keys(this?.duplicateColumnsData).length > 1 && newValue !== handleFillCellsOldValue && !e?.is_deleted){
          if(columnTypeId == "4" || columnTypeId == "16"){
            newValue = this.formatDateTimeValue(newValue);
            handleFillCellsOldValue = this.formatDateTimeValue(handleFillCellsOldValue);
          }
          if (!this.isSubsheet){
            if (this.duplicateRowsThatNeedCountUpdation.hasOwnProperty(rowKey) && this.duplicateRowsThatNeedCountUpdation[rowKey].hasOwnProperty(e.colDef.dataIndex + '_is_deleted') && this.duplicateRowsThatNeedCountUpdation[rowKey][e.colDef.dataIndex + '_is_deleted']) {
              if (this.duplicateRowsThatNeedCountUpdation[rowKey][e.colDef.dataIndex] !== newValue) {
                this.modifyDuplicatesCountWhenCellValueChanged(columnTypeId, newValue, handleFillCellsOldValue, e.colDef.dataIndex, e.colDef.cellRendererParams.columnOptions?.is_highlighted, '', oldRowNodeData, e.node?.data);
              }
              this.duplicateRowsThatNeedCountUpdation[rowKey][e.colDef.dataIndex + '_is_deleted'] = false;
            } else {
              this.modifyDuplicatesCountWhenCellValueChanged(columnTypeId, newValue, handleFillCellsOldValue, e.colDef.dataIndex, e.colDef.cellRendererParams.columnOptions?.is_highlighted, '', oldRowNodeData, e.node?.data);
            }
          } else if (this.isSubsheet && !isNewRowInSubsheet) {
            this.modifyDuplicatesCountWhenCellValueChanged(columnTypeId, newValue, handleFillCellsOldValue, e.colDef.dataIndex + '_' + this.parentRowId, e.colDef.cellRendererParams.columnOptions?.is_highlighted, e.colDef.dataIndex, oldRowNodeData, e.node?.data, true);
          }
        }
        if (Object.keys(this.duplicateColumnsData).length > 1 && this.isSubsheet && isNewRowInSubsheet) {
          const highlightedColumnIds = Object.keys(this.duplicateColumnsData);
          highlightedColumnIds.forEach(columnId => {
            if (columnId !== "themeColor") {
              const colId = columnId.split('_')[1];
              const subsheetColumnId = columnId.slice(0, columnId.lastIndexOf('_'));
              let newRowValue = valueData[colId]?.value ?? '';
              if (this.duplicateColumnsConfigs[columnId]?.column_type_id == '4' || this.duplicateColumnsConfigs[columnId]?.column_type_id == '16') {
                newRowValue = this.formatDateTimeValue(newRowValue);
              }
              if (this.isValidCellValue(valueData[colId]['column_type_id'], newRowValue)) {
                  this.modifyDuplicatesDataCount(columnId, newRowValue, true, rowId, subsheetColumnId);
              }
            }
          });
        }
      } catch (e) {
        console.log('Error', e);
      }

      this.refreshRowForColoring(e.node, e?.source || "");
      if(this.isLazyLoadEnabled) {
        this.executePendingActions();
      }
      if(this.isSubsheet){
        this.resetSavedRowsCount = !this.resetSavedRowsCount;
      }
    } catch (error) {
      console.log(error);
    }
  }

  refreshRowForColoring = (node, isPasted = "") => {
    // if ((this.listConfig && Object.values(this.listConfig.colorCodes).flat().length == 0) && this.userEvents.length === 0) {
    //   return;
    // }
    let editingCells = this.gridApi?.getEditingCells();
    if (
      editingCells.length > 0 &&
      editingCells[0].rowIndex == node.rowIndex
    ) {
      this.nodesToRefresh.push(node);
    } else {
      this.gridApi?.redrawRows({ rowNodes: [node] });
      let focusedCell = this.gridApi?.getFocusedCell();
      if (focusedCell && node.rowIndex == focusedCell.rowIndex) {
        this.gridApi?.setFocusedCell(focusedCell.rowIndex, focusedCell.column?.colId);
        // try {
        //   if (isPasted == "paste" && focusedCell?.column?.colDef?.cellRendererParams?.columnTypeId == "8") {
        //     this.gridApi.clearRangeSelection();
        //     this.gridApi.clearFocusedCell();
        //     setTimeout(() => {
        //       // this.gridApi?.flashCells({
        //       //   rowNodes: [node],
        //       //   columns: [focusedCell.column?.colId]
        //       // })
        //       this.gridApi?.setFocusedCell(focusedCell.rowIndex, focusedCell.column?.colId);
        //     }, 1);
        //   }
        //   else {
        //     this.gridApi?.setFocusedCell(focusedCell.rowIndex, focusedCell.column?.colId);
        //   }
        // }
        // catch (e) {
        //   this.gridApi?.setFocusedCell(focusedCell.rowIndex, focusedCell.column?.colId);
        // }
      }
    }
  };

  executePendingActions = () => {
    if(this.pendingActions.length > 0) {
      const action = this.pendingActions[0];
      action.action(action.param1, action.param2);
      if(this.view?.options?.options?.default_sort_direction == "DESC") {
        window.appStore.notificationStore.showNotification(
          "Newly created rows moved to the top",
          "success"
        );
      }
      this.pendingActions = [];
    }
  }

  async fetchRowData(e, rowId) {
    const resp = await ApiClient.Views.getViewData({
      list_id: this.listId,
      view_id: this.viewId,
      criteria: `${toUpperCamelCase(this.listConfig.list.name)}.id = ${rowId}`,
      is_web: 1,
    });
    const data = resp.data.data[0];

    e.node.data = { ...e.node.data, ...data };
    e.node.setData(e.node.data);
  }

  async addRowIdInPendingApiCalls(rowIndex, rowId) {
    this.pendingApiCalls[rowIndex].forEach();
  }

  showAddColumn = (columnId, operation, gridApi) => {
    // window.appStore.showAddColumn(columnId); //todo check this;
    this.addColumnStore.setData(columnId, operation, gridApi);
    this.addColumnStore.setOpen(true);
  }

  handleEvents = function (e) {
    try {
      var handlers = this.getHandlers(e?.colDef?.cellEditorParams?.eventHandlers ?? []),
        me = this;

      if (handlers.length > 0) {
        for (var i = 0; i < handlers.length; i++) {
          var handler = handlers[i];
          switch (handler["type"]) {
            case "formula":
              this.triggerFormula(e, handler, false);
              break;
            case "expressionformula":
              this.triggerFormula(e, handler, true);
              break;
            case "lookupfilter":
              //todo handle this;
              break;
            default:
              console.log(handler["type"])
          }
        }
      }
    } catch (e) {
      console.log(e.description);
    }
  };

  getHandlers = function (events) {
    var handlers = [],
      allEvents = [];

    if (events.system?.length > 0 || events.user?.length > 0) {
      allEvents = events.system.concat(events.user);

      for (var j = 0; j < allEvents.length; j++) {
        var handler = allEvents[j].handler;

        if (typeof handler.type == "undefined") {
          handlers.push({ type: "formula", handler: handler });
        } else if (handler.type === "expressionformula") {
          /*else if (TL.list["form-events"].EventManager.isFormFieldHandler(handler.type)) {
                   handlers.push(handler);
               } */
          handlers.push(handler);
        }
      }
    }

    return handlers;
  };

  triggerFormula = async (e, handler, isExpression) => {
    const data = e.node.data;
    const formData = this.getFormDataFormatted(data, true);
    // let oldFormulaValue;
    try {
      if (handler.data?.expression_column_id) {
        // oldFormulaValue = e.node.data["column_" + handler.data.expression_column_id];
        e.node.data["column_" + handler.data.expression_column_id] =
          "calculating...";
        e.node.setData(e.node.data);
      }

      if (e.node.data.row_id && !this.isSubsheet) {
        return; // ignore if already saved;
      }

      let value = e.newValue;
      if (e.colDef.cellRendererParams.columnTypeId == 10) {
        value = { value };
      }

      const rowData = [{ currentRow: formData, listId: this.listId }];
      if (this.parentRow) {
        rowData.push({ parentRow: this.parentRow, listId: this.parentListId });
      }

      const resp = await ApiClient.Formula.evaluate({
        rowData: rowData,
        list_id: this.listId,
        column_id: e.colDef.field.replace("column_", ""),
        value: value,
        is_expression: isExpression
      });

      const udpatedData = resp.data[0].currentRow;

      if (e.node.data.row_id && !this.isSubsheet) {
        return; // ignore if already saved;
      }

      Object.keys(udpatedData).forEach((colId) => {
        e.node.data["column_" + colId] = udpatedData[colId].value;
      });

      e.node.setData(e.node.data);
    } catch (err) {
      console.log(err);
      if (handler.data?.expression_column_id) {
        e.node.data["column_" + handler.data.expression_column_id] =
          "error evaluating...";
        e.node.setData(e.node.data);
      }
    }
  };

  getDataForSave = () => {
    try {
      const data = [];
  
      [...this.allRowsData, ...this.newRows].forEach((row) => {
        // if (!row.isModified) {
        //   return;
        // }
  
        const formattedRow = this.getFormDataFormatted(row, true, true);
        if (formattedRow) {
          data.push(formattedRow);
        }
      })
  
      console.log("data for save", data);
      return data;
    } catch (error) {
      console.log("Data formatting Error ", error);
      return [];
    }
  }

  async handleViewChange(columnConfig, isScrollToAddColumn) {
    this.formatColumns(this.view.options.columns);
    this.previousScrollLeft = !isScrollToAddColumn ? this.gridApi.gridPanel.getHScrollPosition().left : 0;

    this.gridApi.setColumnDefs([]);
    this.gridApi.setColumnDefs(this.columnDefs);
    isScrollToAddColumn && this.gridApi.ensureColumnVisible("+");
    if (columnConfig.column_type_id == 7 || columnConfig.column_type_id == 19) {
      await this.refreshData();
    }
  }

  handleViewColumnsWidthChanged = async (columnDefs) => {
    if (this.isSubsheet) {
      return; //todo: handle this;
    }

    columnDefs.forEach(columnDef => {
      const columnId = columnDef.colDef.cellRendererParams.columnId;

      const column = this.view.options.columns.find(col => {
        return col.id == columnId;
      });
    if(columnDef?.colId == "Id" || columnDef?.colId == "userEvents" || columnDef?.colId == "commentsId"){
        this.handleNonMainColumnsWidthChange({[columnDef.colId] : columnDef.actualWidth});
      }
      if (!column) {
        return;
      }
      column.col_width = columnDef.actualWidth;
    })

    await this.saveView();
  };

  handleViewColumnsOrderChange = async (e) => {
    if (this.isSubsheet && this.columns.length < 7) {
      if (e.pinned == "right") {
        e.columnApi.applyColumnState({
          state: [{ colId: "$Events", pinned: "right" }],
        });
      } else if (
        (e.pinned == null || e.pinned == "left") &&
        e.columnApi.getDisplayedRightColumns().length == 1
      ) {
        e.columnApi.applyColumnState({
          state: [{ colId: "$Events", pinned: null }],
        });
      }
    }
    if (this.isSubsheet) {
      if (e?.type == "dragStopped") {
        let columnOrder = {},
          subsheeViewId;
        e.columnApi?.columnController?.allDisplayedColumns?.forEach((col, index) => {
          if (
            col.colDef?.cellRendererParams?.columnId &&
            col.colDef?.cellRendererParams?.columnId != "row_id" &&
            col.colDef?.cellRendererParams?.columnId != "event" &&
            col.colDef?.colId != "createdBy" &&
            col.colDef?.cellRendererParams?.columnRaw?.default_type != "1"
          ) {
            columnOrder[col.colDef.cellRendererParams.columnId] = index + 1;
          }
        });
        try {
          this.props?.columns?.forEach((column) => {
            if (column && column.hasOwnProperty("view_id") && column.view_id) {
              subsheeViewId = column.view_id;
              return;
            }
          });

          if (subsheeViewId) {
            const resp = await ApiClient.Views.subsheetColumnOrdering({
              view_id: subsheeViewId,
              column_order: JSON.stringify(columnOrder),
            });
            if (resp.success) {
              window.appStore?.containerStore?.changeSubsheetColumnsPosition(
                this.props.columnId,
                columnOrder
              );
            }
          }
        } catch (e) {}
      }
      return; //todo: handle this;
    }
    const newColumnDefs = [];
    e.columnApi.columnController.allDisplayedColumns.forEach((col) => {
      col.colDef.pinned = col.pinned;
      newColumnDefs.push(col.colDef)
    })
    newColumnDefs.forEach((columnDef, index) => {
      const columnId = columnDef.cellRendererParams.columnId;
      const column = this.view.options.columns.find(col => {
        return col.id == columnId;
      });

      if (!column) {
        return;
      }

      column.order = index;
      column.pinned = columnDef.pinned;

      const columnDefOld = this.columnDefs.find(col => col.colId === columnDef.colId); //to cache for sheet change
      if (columnDefOld) {
        columnDefOld.pinned = columnDef.pinned;
        columnDefOld.order = index;
      }
    });
    this.view.options.columns = this.view.options.columns.slice().sort((a, b) => a.order - b.order);
    this.columnDefs = this.columnDefs.slice().sort((a, b) => a.order - b.order);
    await this.saveView();
  }

  handleRowHeightChange = (rowHeight) => {
    this.view.options.options = this.view.options.options ?? {};
    this.view.options.options.row_height = rowHeight;
    // this.view = { ...this.view };

    this.saveView();
  }

  handleNonMainColumnsWidthChange = (widthObj) => {
    try{
      this.view.options.options = this.view?.options?.options ?? {};
      if(widthObj["userEvents"]) {
        this.view.options.options.userEventsColumnWidth = widthObj["userEvents"];
      }
      if(widthObj["Id"]) {
        this.view.options.options.idColumnWidth = widthObj["Id"];
      }
      if(widthObj["commentsId"]){
        this.view.options.options.commentsIdColumnWidth = widthObj["commentsId"]
      }
    }
    catch(e){
      console.log(e);
    }
  }

  getRowHeight() {
    return this.view?.options?.options?.row_height ?? DIMENSIONS.cell_height_short
  }

  //TODO: check and remove this function.
  getView = async () => {
    if (this.view) {
      return;
    }

    const resp = await ApiClient.Views.getView({
      list_id: this.listId,
      view_id: this.viewId
    });

    this.view = resp.data;
  };

  saveView = async () => {
    try {
      const filteredView = this.containerStore.getviewToSaveWithoutHeaderInColumns(this.view);
      const resp = await ApiClient.Views.saveView({
        list_id: this.listId,
        view: filteredView,
        is_edit: true,
      })
    } catch (e) {
      console.log(e);
    }
  };

  saveViewOptions = async () => {
    try {
      if (this.view && this.view.id && this.view.options?.rowViewHeader) {
        const resp = await ApiClient.Views.saveViewOptions({
          list_id: this.listId,
          view_id: this.view.id,
          rowViewHeader: this.view.options.rowViewHeader,
          user_id: window.LOGGED_IN_USER.user_id ?? ''
        });
        if (resp.msg) {
          console.log(resp.msg);
        }
        return true;
      }
    } catch (e) {
      console.log(e);
    }
  };

  formatColumns = (columns, ignoreDefaultColumns = false) => {
    columns = columns ?? this.view?.options.columns;
    columns.forEach(col => {
      col["name"] = col['name'] ?? col['header'] ?? this.listConfig.listData.find(listCol => listCol.alias_path === col.alias_path)?.['name'] ?? col.alias_path

      if (parseInt(col['column_type_id']) === 6 && !col["list_columns"]) {
        col["list_columns"] = this.listConfig.listData.find(listCol => listCol.alias_path === col.alias_path)?.['list_columns']
      }
      if (!col['alias_path']) {
        col['alias_path'] = col['alias_name'];//TODO: check this;
      }
    });
    columns = uniqBy(columns, 'alias_path');

    const listId = this.listId;
    const actionsColWidth = preCalculateActionsColumnWidth(this.userEvents);

    // this.viewColumns = columns;
    columns.forEach((column) => {
      if (typeof column.options == "string") {
        column.options = JSON.parse(column.options)[0]; //updates columns also
      }
      return column;
    });
    const idColumnWidth = +this.view?.options?.options?.idColumnWidth;
    const userEventsColumnWidth = +this.view?.options?.options?.userEventsColumnWidth;
    const commentsIdColumnWidth = +this.view?.options?.options?.commentsIdColumnWidth;
    if(this.view?.type == "table" && 
       this.view?.list_id &&
       this.view?.options?.main_list_id &&
       this.view?.list_id != this.view?.options?.main_list_id
      ) {
      this.columns = [
        {
          id: "row_id",
          col_width: idColumnWidth >= 120 ? idColumnWidth : this.isSubsheet ? 100 : 140,
          dataIndex: "row_id",
          column_type_id: "id",
          alias_path: "Id",
          text: "Id",
          list_id: listId,
          header: "Id",
          alias_name: "id",
        },
        {
          id: "parent_row_id",
          col_width: 150,
          dataIndex: "parent_row_id",
          column_type_id: "parentRowId",
          alias_path: "Parent Row Id",
          text: "Parent Row Id",
          list_id: listId,
          header: "Parent Row Id",
          alias_name: "Parent Row Id",
        },
        ...columns,
      ];
    } else {
      this.columns = [
        {
          id: "row_id",
          col_width: idColumnWidth >= 120 ? idColumnWidth : this.isSubsheet ? 100 : 140,
          dataIndex: "row_id",
          column_type_id: "id",
          alias_path: "Id",
          // alias_path: `${toUpperCamelCase(this.listConfig.list.name)}.id`,
          text: "Id",
          list_id: listId,
          header: "Id",
          alias_name: "id",
        },
        ...(!this.isSubsheet && ( typeof this.view?.options?.options?.is_comments_column_visible == "undefined" || this.view?.options?.options?.is_comments_column_visible === true)
          ? [
              {
                id: "comments_id",
                name:"Notes/Comments",
                col_width: commentsIdColumnWidth ? commentsIdColumnWidth : 300,
                dataIndex: "comments_id",
                column_type_id: "comments_id",
                alias_path: "commentsId",
                text: "",
                list_id: listId,
                header: "Notes/Comments",
                alias_name: "comments",
              },
            ]
          : []),
           
        ...columns,
      ];
    }
    if (this.userEvents.length) {
      // this.columns.splice(1, 0, {
      //   id: "actions",
      //   col_width: actionsColWidth,
      //   dataIndex: "actions",
      //   column_type_id: "actions",
      //   alias_path: "Actions",
      //   text: "Actions",
      //   list_id: listId,
      //   header: "Actions",
      //   alias_name: "actions",
      // })
    }
    if (this.isSubsheet) {
      for (var i = 0; i < this.columns.length; i++) {
        if (this.columns[i].alias_path == "createdBy") {
          var column = this.columns[i];
          this.columns.splice(i, 1);
          this.columns.splice(this.columns.length, 0, column); //positioning createdBy as last column in subsheet
          break;
        }
      }

    }
    if (this.isSubsheet && !this.isEventsColumnHidden) {
      this.columns.push({
        id: "event",
        col_width: 0,
        dataIndex: "events",
        column_type_id: "events",
        alias_path: "$Events",
        text: "Events",
        list_id: listId,
        header: "$Events",
        alias_name: "events",
      });
    }
    this.columnsFormatted = columns.map((column) => {
      if (typeof column.options == "string") {
        column.options = JSON.parse(column.options)[0]; //updates columns also
      }
      return column;
    });

    this.columnsFormatted = columns;
    this.mandatoryColumns = this.columnsFormatted.filter(
      (column) => column.options?.is_mandatory
    );
    let buttonsForTriggerColumn = 0;
    this.userEvents.map(event => {
        if (event.position.split(",").includes("column")) {
            buttonsForTriggerColumn += 1
        }
        return 1
    })
    const isMainView = this.view?.is_main_view ?? 0;
    const { columnDefs, columnsWithAggregation } = getColumnsArray(this.columns, !this.isTableConfigReadOnly, isMainView, this.isSubsheet, userEventsColumnWidth, this.view);
    this.columnDefs = this.addConfigToColumnDefs(columnDefs);
    this.columnsWithAggregation = columnsWithAggregation;
  }

  updateColumnsWithAggregation = (colDataField, aggregationType) => {
    this.columnsWithAggregation[colDataField] = aggregationType
  }

  formatDataForGrid = (data) => {
    if (!data) {
      return data;
    }
    if (data[0]?.uniqueId) {
      return data;
    }

    data.forEach(dat => {
      if (!dat.row_id) {
        return; //for new rows
      }
      dat.uniqueId = dat.row_id;
    })

    return data;
  }

  get formattedData() {
    const addRowData = this.getAddRowData();
    return [...this.data, addRowData];
  }

  getAddGroupedRowData(initialData = {}, addRow = {}) {
    this.columnDefs.forEach((colDef) => {
      addRow[colDef.field] = initialData[colDef.field] ?? "";
    });
    addRow.row_id = "+";
    if (!addRow.uniqueId) {
      addRow.uniqueId = getUniqueId();
    }

    return addRow;
  }

  getAddRowData(initialData = {}) {
    const addRow = {}

    this.columnDefs.forEach(colDef => {
      addRow[colDef.field] = initialData[colDef.field] ?? "+r0w"
    })
    addRow.row_id = "+"
    addRow.uniqueId = getUniqueId();

    return addRow;
  }

  formatSubsheetData = (value) => {
    if (typeof value != "object") {
      return [];
    }
    const rows = [];

    value.forEach(val => {
      const row = {};
      Object.keys(val).forEach(key => {
        const isModified = val[key]['is_modified'];
        let value = val[key]['value'];

        if (val[key].column_type_id == 10) {
          value = JSON.parse(value);
        }
        row["row_id"] = val[key]['row_id'];
        row["column_" + key] = value;
        row["column_" + key + '_isModified'] = isModified;
      });

      rows.push(row);
    })

    return rows;
  }

  jumpToLastRow() {
    if (this.isLazyLoadEnabled) {
      if (
        this.gridApi.getInfiniteRowCount() <
        this.allVisibleGridRowsCount - 1
      ) {
        this.gridApi.setInfiniteRowCount(
          this.allVisibleGridRowsCount - 1,
          false
        );
      }
      this.gridApi.ensureIndexVisible(this.allVisibleGridRowsCount - 1);
    } else {
      let loadAllRowsData = [];
      this.gridApi.forEachNode(function (node) {
        loadAllRowsData.push(node.data);
      });
      this.gridApi.ensureIndexVisible(loadAllRowsData.length - 1);
    }
  }

  getNewRow(newRowInitialData) {
    const newRow = observable({});

    newRowInitialData = { ...newRowInitialData };
    delete newRowInitialData.row_id;
    delete newRowInitialData.uniqueId;
    this.columnDefs.map((column) => {
      const columnOptions = column.cellRendererParams.columnOptions;
      const columnTypeId = column.cellRendererParams.columnTypeId;

      // console.log(toJS(column));
      newRow[column.field] = newRowInitialData[column.field] && newRowInitialData[column.field] != "+r0w"
        ? newRowInitialData[column.field]
        : this.getDefaultValue(columnTypeId, columnOptions)
      return 0;
    });

    newRow.uniqueId = getUniqueId();
    this.newRows.push(newRow);
    return newRow;
  }

  getKeyCreatorValue(params, column) {
    return this.getColumnValue(column, params.value);
  }

  getDefaultValue(columnTypeId, opt) {
    if (!columnTypeId) {
      return "";
    }

    switch (columnTypeId) {
      // case "1":
      //Text";
      // case "2":
      //Checkbox";
      case "3":
      case "1":
      case "5":
      case "11":
      case "13":
        if (opt?.default_value) {
          return opt.default_value;
        }
      //ComboBox";
      case "4":
        //Date
        if (opt?.default_current_time) {
          return moment().format("YYYY-MM-DD 00:00:00");
        }
      // case "5":
      //Number";
      // case "6":
      //Sheet";
      // case "7":
      //Formula";
      // case "8":
      //TextArea";
      // case "9":
      //File";
      case "10":
        //Lookup";
        //todo: should call event handlers
        return "";
      // case "11":
      //MultiComboBox";
      // case "12":
      //Checkbox";
      // case "13":
      //CheckboxGroup";
      case "14":
        //Email";
        if (opt?.default_email) {
          return window.LOGGED_IN_USER.email;
        }
      // case "15":
      //Password";
      case "16":
        //DateTime";
        if (opt?.default_current_time) {
          return moment().format("YYYY-MM-DD hh:mm:ss")
        }
      // case "17":
      //Currency";
      // case "18":
      //Barcode";
      // case "19":
      //ExpressionFormula";
    }

    return "";
  }

  handleQuickSearchChange = (value) => {
    this.quickSearchText = value;
    this.updateGridWithSearchText(value);
  }

  updateGridWithSearchText = debounce((value) => {
    if (this.shouldLoadAllRows) {
      this.gridApi.setQuickFilter(value)
      return;
    }
    this.gridApi.purgeInfiniteCache();
  }, 500)

  refreshGrid = (params, column) => {
    var columnDefs = this.columnDefs;
    const isMainView = this.view?.is_main_view ?? 0;

    columnDefs.splice(columnDefs.length - 1, 0, getColumnDef(column, isMainView));
    params.api.setColumnDefs([]);
    params.api.setColumnDefs(columnDefs);
    params.api.redrawRows();
    params.api.ensureColumnVisible("+");
    columnDefs.map((colDef, index) => {
      if (colDef.colId.substring(0, 4) === "Test") {
        let array = Array.from(
          document.querySelectorAll(`[col-id*=` + colDef.colId + `]`)
        );
        if (array.length) {
          array[array.length - 2].classList.add("no-border");
          array[array.length - 2].classList.add("border-top-add-row");
        }
      }
    });
  }

  static addSpecialColumns(columns) {
    var isPasswordExist = false;
    let index;

    for (var i = 0; i < columns.length; i++) {
      if (columns[i].alias_path === "UserAccounts.email") { //TODO: Check if we can use alias instead of index.
        index = i + 1;
      }

      if (columns[i].alias_name === "password") {
        isPasswordExist = true;
        break;
      }
    }

    if (!isPasswordExist) {
      var col = {
        "view_id": null,
        "col_width": "170",
        "id": "password",
        "header": "Password",
        "column_type_id": "15",
        "name": "Password",
        "options": "[{\"is_mandatory\":false}]",
        "alias_name": "password",
        "event_handlers": "{\"system\":[],\"user\":[]}",
        "default_type": "0",
        "is_default": 1,
        "dataIndex": "password",
        "group_id": 0
      };
      if (index > 0) {
        columns.splice(index, 0, col);
      }
    }

    return columns;
  }

  getObjectKeysHACK = () => []
}

decorate(TableStore, {
  cellMetaData: observable,
  data: observable,
  // columns: observable,
  columnDefs: observable,
  columnsWithAggregation: observable,
  currentApiCallsCount: observable,
  isCurrentRowSaving: observable,
  isLoading: observable,
  parentRow: observable,
  isScrollToLastButtonVisible: observable,
  gridApi: observable,
  gridParams: observable,
  isLazyLoadEnabled: observable,
  allSavedRowsCount: observable,
  resetSavedRowsCount: observable,
  view: computed,
  quickSearchText: observable,
  isColumnDeleting: observable,
  isTabNameChanging: observable,
  isSheetDeleting: observable,
  isMailModalVisible: observable,
  isExportingLazyLoadData: observable,
  isCommentsColumnSaving: observable,
  isViewSaving: observable,
  isGridCellEditing: observable,
  isSubsheetRecordsDeleted: observable,
  currentCommentsElement: observable,
  currentCommenteGridCell: observable,
  isRowViewEditorOpen: observable,
  rowDetailScrollPos: observable,
  formattedData: computed,
  shouldLoadAllRows: computed,
  isGridGrouped: computed,
  currentRowsCount: computed,
  // activeToolbarActionButtons: computed, //
  userEvents: observable,
  noOfRecordsSelected: observable,
  isGridFiltersActive: observable,
  isCommentsColumnPrev : observable,
  modifiedCriteria: observable,
  isCriteriaModified: observable,
  isSortModified: computed,
  actionButtons: observable,
  isActionButtonsPopperOpen: observable,
  newColumns: observable,
  errorTooltip: observable,
  overflowTooltip: observable,
  loadTypeButtonShown: observable,
  isNewColumnAdded: observable,
  hiddenColumns: observable,
  previousRowIndexSelected: observable,
  currentRowIndexSelected: observable,
  executingEvents: observable,
  executingToolbarEvents: observable,
  loadingColumns: observable,
  handleSubsheetColumnConfigChange: action,
  comments: observable,
  rowsWithRestoreIcon: observable,
  // newRows: observable,
  // pendingApiCalls: observable,

  // getHoverMessage: action
});
// const TableStore = new TableStore();
export default TableStore;


//todo: use tigersheet Util Class after merge.. 
const toCamelCase = function (s) {
  s = s || '';
  // remove all characters that should not be in a variable name
  // as well underscores an numbers from the beginning of the string
  s = s.replace(/([^a-zA-Z0-9_\- ])|^[_0-9]+/g, "").trim().toLowerCase();
  // uppercase letters preceeded by a hyphen or a space
  s = s.replace(/([ -]+)([a-zA-Z0-9])/g, function (a, b, c) {
    return c.toUpperCase();
  });
  // uppercase letters following numbers
  s = s.replace(/([0-9]+)([a-zA-Z])/g, function (a, b, c) {
    return b + c.toUpperCase();
  });
  return s;
}

const toUpperCamelCase = function (string) {
  string = toCamelCase(string);
  return string.charAt(0).toUpperCase() + string.slice(1);
}
